/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState, useRef } from "react";
import { Col, Container, Row, Form, Button, Card } from "react-bootstrap";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import "../../css/product-details.css";
import "../../css/addproduct.css";
import axios from "axios";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import baseUrl from "../../Environment";
import { RotatingLines } from "react-loader-spinner";

export default function AddProduct() {
  const [dnewCat, setDnewCat] = useState("none");
  const [dnewSubCat, setDnewSubCat] = useState("none");
  const [data, setData] = useState([]);
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [variantTable, setVariantTable] = useState("none");
  const [coverTable, setCoverTable] = useState("none");
  const [txt, setTxt] = useState(false);
  const [editingIndex, setEditingIndex] = useState(null);
  const [editingCoverIndex, setEditingCoverIndex] = useState(null);
  const [showVarInput, setShowVarInput] = useState("none");
  const [varSize, setVarSize] = useState([]);
  const [bColor, setBcolor] = useState("#ccc");
  const [isEditing, setIsEditing] = useState(false);
  const [disableCover, setDisableCover] = useState(true);
  const [validatedvarient, setValidatedvarient] = useState(false);
  const [validated, setValidated] = useState(false);
  const [coverValidated, setCoverValidated] = useState(false);
  const [showVarButton, setShowVarBtton] = useState(true);
  const location = useLocation();
  const navigate = useNavigate();
  const [Loading, setLoading] = useState(false);
  // ── Refs for clearing file inputs ──
  const bgImageInputRef = useRef(null);
  const mobileBgImageInputRef = useRef(null);
  const itemIconInputRef = useRef(null);
  const [colorData, setColorData] = useState({
    colorName: "",
    colorCode: "#4A7043",
    images: [],
  });
  const [editingColorIndex, setEditingColorIndex] = useState(null);
  const [colorHistory, setColorHistory] = useState([]);
  const [colorValidated, setColorValidated] = useState(false);
  const colorImageInputRef = useRef(null);
  const [formData, setFormData] = useState({
    title: "",
    seriesName: "",
    tagline: "",
    description: "",
    mattressTypeInfo: {
      type: "",
      tagline: "",
    },
    category: "",
    subcategory: "",
    offerdescription: "",
    offercode: "",
    variants: [],
    bedsheetType: "",
    bedsheetColors: [],
    weight: "",
    covers: [],
    material: [],
    firmness: [],
    // imageurl holds both existing GCP URL strings (when editing) and new File objects
    imageurl: [],
    // These arrays collect GCP URLs to be deleted on save
    deleteImageUrls: [],
    deleteCoverImageUrls: [],
    deleteLayerImageUrls: [],
    deleteColorImageUrls: [],
    // NEW: collects existing GCP URLs for feature-tab item icons and
    // feature background / mobile background images that are removed
    // outright or replaced with a new file, so the backend can clean
    // them up from GCP on save. Without these, old icon/background
    // blobs were silently orphaned forever.
    deleteFeatureIconUrls: [],
    deleteFeatureBgUrls: [],
    featureSection: {
      mainTitle: "",
      mainDescription: "",
      backgroundImage: null,
      mobileBackgroundImage: null,
      tabs: [],
    },
    layerSection: {
      mainTitle: "",
      mainDescription: "",
      subDescription: "",
      layers: [],
    },
    isBestSeller: false,
  });

  const [newTab, setNewTab] = useState({ tabTitle: "", tabSubtitle: "" });
  const [newItem, setNewItem] = useState({
    icon: null,
    title: "",
    description: "",
  });
  const [currentTabIndex, setCurrentTabIndex] = useState(null);
  const [editingTabIndex, setEditingTabIndex] = useState(null);
  const [editingItemIndex, setEditingItemIndex] = useState(null);
  const [newLayer, setNewLayer] = useState({
    layerNumber: "",
    title: "",
    subtitle: "",
    description: "",
    image: null,
  });
  const [editingLayerIndex, setEditingLayerIndex] = useState(null);

  // ─────────────────────────────────────────────
  // Feature Section Handlers
  // ─────────────────────────────────────────────
  const handleFeatureChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      featureSection: { ...prev.featureSection, [field]: value },
    }));
  };
  const handleBestSellerChange = (e) => {
    setFormData((prev) => ({ ...prev, isBestSeller: e.target.checked }));
  };
  /**
   * Replace/remove the feature Background Image or Mobile Background
   * Image. If the value currently in place is an existing GCP URL (not a
   * File) and it is being replaced with a new file, or removed outright
   * (newValue === null), the old URL is queued in deleteFeatureBgUrls so
   * the backend deletes it from GCP on save.
   */
  const setFeatureBgField = (field, newValue) => {
    setFormData((prev) => {
      const oldValue = prev.featureSection[field];
      const deleteFeatureBgUrls = [...(prev.deleteFeatureBgUrls || [])];
      if (
        oldValue &&
        !(oldValue instanceof File) &&
        (newValue instanceof File || newValue === null)
      ) {
        deleteFeatureBgUrls.push(oldValue);
      }
      return {
        ...prev,
        deleteFeatureBgUrls,
        featureSection: { ...prev.featureSection, [field]: newValue },
      };
    });
  };

  // Add or Update a Tab (handles both add & edit via editingTabIndex)
  const addFeatureTab = (e) => {
    e.preventDefault();
    if (!newTab.tabTitle.trim()) return toast.warning("Tab Title is required");

    setFormData((prev) => {
      const tabs = [...(prev.featureSection.tabs || [])];
      if (editingTabIndex !== null) {
        tabs[editingTabIndex] = {
          ...tabs[editingTabIndex],
          tabTitle: newTab.tabTitle,
          tabSubtitle: newTab.tabSubtitle || "",
        };
      } else {
        tabs.push({
          tabTitle: newTab.tabTitle,
          tabSubtitle: newTab.tabSubtitle || "",
          items: [],
          _id: Date.now().toString(),
        });
      }
      return { ...prev, featureSection: { ...prev.featureSection, tabs } };
    });

    setNewTab({ tabTitle: "", tabSubtitle: "" });
    setEditingTabIndex(null);
  };

  // Open the Tab modal pre-filled for editing
  const handleEditTab = (tabIndex) => {
    const tab = formData.featureSection.tabs[tabIndex];
    setNewTab({
      tabTitle: tab.tabTitle || "",
      tabSubtitle: tab.tabSubtitle || "",
    });
    setEditingTabIndex(tabIndex);
  };

  // Add or Update an Item within a tab (handles both add & edit via editingItemIndex)
  const addFeatureItem = (e, tabIndex) => {
    e.preventDefault();
    if (tabIndex === null || tabIndex === undefined) return;
    if (!newItem.title || !newItem.description) {
      return toast.warning("Title and Description are required");
    }
    setFormData((prev) => {
      const tabs = [...(prev.featureSection.tabs || [])];
      const items = [...(tabs[tabIndex].items || [])];
      const deleteFeatureIconUrls = [...(prev.deleteFeatureIconUrls || [])];

      if (editingItemIndex !== null) {
        const prevIcon = items[editingItemIndex]?.icon;
        // If the previous icon was an existing GCP URL and it's being
        // replaced with a new file or removed, mark it for deletion.
        if (
          prevIcon &&
          !(prevIcon instanceof File) &&
          (newItem.icon instanceof File || newItem.icon === null)
        ) {
          deleteFeatureIconUrls.push(prevIcon);
        }
        items[editingItemIndex] = { ...items[editingItemIndex], ...newItem };
      } else {
        items.push({ ...newItem, _id: Date.now().toString() });
      }
      tabs[tabIndex] = { ...tabs[tabIndex], items };
      return {
        ...prev,
        deleteFeatureIconUrls,
        featureSection: { ...prev.featureSection, tabs },
      };
    });
    setNewItem({ icon: null, title: "", description: "" });
    setEditingItemIndex(null);
    if (itemIconInputRef.current) itemIconInputRef.current.value = "";
  };

  // Open the Item modal pre-filled for editing
  const handleEditItem = (tabIndex, itemIndex) => {
    const item = formData.featureSection.tabs[tabIndex].items[itemIndex];
    setNewItem({
      icon: item.icon || null,
      title: item.title || "",
      description: item.description || "",
    });
    setCurrentTabIndex(tabIndex);
    setEditingItemIndex(itemIndex);
    if (itemIconInputRef.current) itemIconInputRef.current.value = "";
  };

  const removeTab = (e, index) => {
    e.preventDefault();
    setFormData((prev) => {
      const removedTab = prev.featureSection.tabs[index];
      // Every existing-URL icon inside the tab being removed must be
      // queued for GCP deletion too, not just the tab itself.
      const deleteFeatureIconUrls = [
        ...(prev.deleteFeatureIconUrls || []),
        ...(removedTab?.items || [])
          .map((i) => i.icon)
          .filter((icon) => typeof icon === "string"),
      ];
      return {
        ...prev,
        deleteFeatureIconUrls,
        featureSection: {
          ...prev.featureSection,
          tabs: prev.featureSection.tabs.filter((_, i) => i !== index),
        },
      };
    });
  };

  const removeItem = (e, tabIndex, itemIndex) => {
    e.preventDefault();
    setFormData((prev) => {
      const tabs = [...prev.featureSection.tabs];
      const removed = tabs[tabIndex].items[itemIndex];
      const deleteFeatureIconUrls = [...(prev.deleteFeatureIconUrls || [])];
      if (removed?.icon && typeof removed.icon === "string") {
        deleteFeatureIconUrls.push(removed.icon);
      }
      tabs[tabIndex].items = tabs[tabIndex].items.filter(
        (_, i) => i !== itemIndex,
      );
      return {
        ...prev,
        deleteFeatureIconUrls,
        featureSection: { ...prev.featureSection, tabs },
      };
    });
  };

  // ─────────────────────────────────────────────
  // Layer Section Handlers
  // ─────────────────────────────────────────────
  const handleLayerChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      layerSection: { ...prev.layerSection, [field]: value },
    }));
  };

  // Add or Update a Layer (handles both add & edit via editingLayerIndex)
  const addLayer = (e) => {
    e.preventDefault();
    if (!newLayer.title || !newLayer.layerNumber) {
      return toast.warning("Layer Number and Title are required");
    }

    setFormData((prev) => {
      const layers = [...(prev.layerSection.layers || [])];
      const deleteLayerImageUrls = [...(prev.deleteLayerImageUrls || [])];
      const targetIndex =
        editingLayerIndex !== null ? editingLayerIndex : layers.length;

      let imageFile = newLayer.image;

      // Rename new image files to a predictable layer-<index> filename
      if (imageFile instanceof File) {
        const ext = imageFile.name.split(".").pop();
        imageFile = new File([imageFile], `layer-${targetIndex}.${ext}`, {
          type: imageFile.type,
          lastModified: imageFile.lastModified,
        });
      }

      if (editingLayerIndex !== null) {
        const prevImage = layers[editingLayerIndex]?.image;
        // If the previous image was an existing GCP URL and it's being replaced
        // or removed, mark it for deletion on save.
        if (
          prevImage &&
          !(prevImage instanceof File) &&
          (imageFile instanceof File || imageFile === null)
        ) {
          deleteLayerImageUrls.push(prevImage);
        }
        layers[editingLayerIndex] = {
          ...layers[editingLayerIndex],
          ...newLayer,
          image: imageFile,
        };
      } else {
        layers.push({
          ...newLayer,
          image: imageFile,
          _id: Date.now().toString(),
        });
      }

      return {
        ...prev,
        deleteLayerImageUrls,
        layerSection: { ...prev.layerSection, layers },
      };
    });

    setNewLayer({
      layerNumber: "",
      title: "",
      subtitle: "",
      description: "",
      image: null,
    });
    setEditingLayerIndex(null);
  };

  // Open the Layer modal pre-filled for editing
  const handleEditLayer = (index) => {
    const layer = formData.layerSection.layers[index];
    setNewLayer({
      layerNumber: layer.layerNumber || "",
      title: layer.title || "",
      subtitle: layer.subtitle || "",
      description: layer.description || "",
      image: layer.image || null,
    });
    setEditingLayerIndex(index);
  };

  const removeLayer = (e, index) => {
    e.preventDefault();
    setFormData((prev) => {
      const layerToRemove = prev.layerSection.layers[index];
      const deleteLayerImageUrls = [...(prev.deleteLayerImageUrls || [])];
      // If the layer has an existing GCP URL (not a File), mark it for deletion
      if (layerToRemove.image && !(layerToRemove.image instanceof File)) {
        deleteLayerImageUrls.push(layerToRemove.image);
      }
      return {
        ...prev,
        deleteLayerImageUrls,
        layerSection: {
          ...prev.layerSection,
          layers: prev.layerSection.layers.filter((_, i) => i !== index),
        },
      };
    });
  };
  // ─────────────────────────────────────────────
  // Bedsheet Color handlers
  // ─────────────────────────────────────────────
  const handleColorChange = (e) => {
    const { name, value } = e.target;
    setColorData((prev) => ({ ...prev, [name]: value }));
  };

  const handleColorFileUpload = (e) => {
    const files = Array.from(e.target.files).filter((f) =>
      f.type.startsWith("image/"),
    );
    if (files.length > 0) {
      setColorData((prev) => ({ ...prev, images: [...prev.images, ...files] }));
    }
  };

  const handleColorDrop = (e) => {
    e.preventDefault();
    const files = Array.from(e.dataTransfer.files).filter((f) =>
      f.type.startsWith("image/"),
    );
    if (files.length > 0) {
      setColorData((prev) => ({ ...prev, images: [...prev.images, ...files] }));
    }
  };

  const handleColorDragOver = (e) => e.preventDefault();

  const removeColorImage = (index) => {
    setColorData((prev) => {
      const imageToRemove = prev.images[index];
      // If it's an existing GCP URL, mark it for deletion on save
      if (imageToRemove && !(imageToRemove instanceof File)) {
        setFormData((fd) => ({
          ...fd,
          deleteColorImageUrls: [
            ...(fd.deleteColorImageUrls ?? []),
            imageToRemove,
          ],
        }));
      }
      return { ...prev, images: prev.images.filter((_, i) => i !== index) };
    });
  };

  const handleColorFormSubmit = (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.stopPropagation();
      setColorValidated(true);
      return;
    }
    if (!colorData.colorName.trim()) {
      return toast.warning("Color name is required");
    }
    if (!colorData.images || colorData.images.length === 0) {
      return toast.warning("At least one image is required for this color");
    }

    const newColor = {
      _id:
        colorData._id ||
        (editingColorIndex !== null
          ? formData.bedsheetColors[editingColorIndex]?._id
          : null),
      colorName: colorData.colorName,
      colorCode: colorData.colorCode,
      images: colorData.images,
    };

    setFormData((prevFormData) => {
      if (editingColorIndex !== null) {
        const updatedColors = [...(prevFormData.bedsheetColors || [])];
        updatedColors[editingColorIndex] = newColor;

        setColorHistory((prevHistory) => {
          const actionIndex = prevHistory.findIndex(
            (entry) => entry.action === "modified",
          );
          if (actionIndex !== -1) {
            const updatedHistory = [...prevHistory];
            updatedHistory[actionIndex] = {
              ...updatedHistory[actionIndex],
              data: [...updatedHistory[actionIndex].data, newColor],
            };
            return updatedHistory;
          }
          return [...prevHistory, { action: "modified", data: [newColor] }];
        });

        return { ...prevFormData, bedsheetColors: updatedColors };
      } else {
        const updatedColors = [
          ...(prevFormData.bedsheetColors || []),
          newColor,
        ];

        setColorHistory((prevHistory) => {
          const actionIndex = prevHistory.findIndex(
            (entry) => entry.action === "new",
          );
          if (actionIndex !== -1) {
            const updatedHistory = [...prevHistory];
            updatedHistory[actionIndex] = {
              ...updatedHistory[actionIndex],
              data: [...updatedHistory[actionIndex].data, newColor],
            };
            return updatedHistory;
          }
          return [...prevHistory, { action: "new", data: [newColor] }];
        });

        return { ...prevFormData, bedsheetColors: updatedColors };
      }
    });

    setColorData({ colorName: "", colorCode: "#4A7043", images: [] });
    setEditingColorIndex(null);
    setColorValidated(false);
    if (colorImageInputRef.current) colorImageInputRef.current.value = "";
    const closeButton = document.querySelector(
      "#color-modal [data-bs-dismiss='modal']",
    );
    if (closeButton) closeButton.click();
  };

  const handleEditColor = (index) => {
    const colorToEdit = formData.bedsheetColors[index];
    setColorData({
      colorName: colorToEdit.colorName || "",
      colorCode: colorToEdit.colorCode || "#4A7043",
      images: colorToEdit.images || [],
      _id: colorToEdit._id || null,
    });
    setEditingColorIndex(index);
  };

  const handleDeleteColor = (index) => {
    setFormData((prevFormData) => {
      const deletedColor = prevFormData.bedsheetColors[index];
      const updatedColors = prevFormData.bedsheetColors.filter(
        (_, i) => i !== index,
      );

      setColorHistory((prevHistory) => {
        const actionIndex = prevHistory.findIndex(
          (entry) => entry.action === "deleted",
        );
        if (actionIndex !== -1) {
          const updatedHistory = [...prevHistory];
          updatedHistory[actionIndex] = {
            ...updatedHistory[actionIndex],
            data: [...updatedHistory[actionIndex].data, deletedColor],
          };
          return updatedHistory;
        }
        return [...prevHistory, { action: "deleted", data: [deletedColor] }];
      });

      return { ...prevFormData, bedsheetColors: updatedColors };
    });
  };
  // ─────────────────────────────────────────────
  // Variant / Cover State
  // ─────────────────────────────────────────────
  const [variantData, setVariantData] = useState({
    thickness: "",
    size: "",
    dimensionsInches: { width: "", height: "", length: "" },
    dimensionsCm: { width: "", height: "", length: "" },
    // ← Add these two:
    bedsheetDimensionsInches: { width: "", length: "", height: "" },
    pillowCoverDimensionsInches: { width: "", length: "" },
    discountPercentage: "",
    price: "",
  });

  const [coverData, setCoverData] = useState({
    name: "",
    notes: "",
    description: "",
    image: null,
  });

  const [variantPayload, setVariantPayload] = useState([]);
  const [coverHistory, setCoverHistory] = useState([]);

  // ─────────────────────────────────────────────
  // Generic field change
  // ─────────────────────────────────────────────
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleCategoryChange = (e) => {
    const { name, value } = e.target;
    if (name === "categoryDropdown" && value === "Add New Category") {
      setDnewCat("block");
      setFormData({ ...formData, category: "" });
    } else if (name === "categoryDropdown") {
      setDnewCat("none");
      setFormData({ ...formData, category: value });
    } else if (name === "categoryInput") {
      setFormData({ ...formData, category: value });
    }
  };

  const handleSubCategoryChange = (e) => {
    const value = e.target.value;
    let updatedFormData = { ...formData, subcategory: value };
    if (value === "Add New") {
      setDnewSubCat("block");
      updatedFormData.subcategory = "";
      setDisableCover(true);
    } else {
      setDnewSubCat("none");
      if (value === "mattresses") {
        setDisableCover(false);
        setShowVarBtton(true);
        if (isEditing && formData.covers && formData.covers.length > 0) {
          setCoverTable("block");
        } else {
          setCoverTable("none");
        }
      } else {
        setDisableCover(true);
        setCoverTable("none");
      }
      updatedFormData.variants = [];
    }
    setFormData(updatedFormData);
  };

  const handleNewSubCategoryInput = (e) => {
    setFormData((prev) => ({ ...prev, subcategory: e.target.value }));
  };

  // ─────────────────────────────────────────────
  // Variant handlers
  // ─────────────────────────────────────────────
  const handleChangeVariants = (e) => {
    const { name, value } = e.target;
    if (value < 0) return;
    const convertInchesToCm = (inches) =>
      Math.floor(Math.round(inches * 2.54 * 100) / 100);
    const convertCmToInches = (cm) =>
      Math.floor(Math.round((cm / 2.54) * 100) / 100);

    if (name.includes(".")) {
      const [parent, child] = name.split(".");
      if (parent === "dimensionsInches") {
        setVariantData((prev) => ({
          ...prev,
          [parent]: { ...prev[parent], [child]: value },
          dimensionsCm: {
            ...prev.dimensionsCm,
            [child]: value ? convertInchesToCm(value) : "",
          },
        }));
      } else if (parent === "dimensionsCm") {
        setVariantData((prev) => ({
          ...prev,
          [parent]: { ...prev[parent], [child]: value },
          dimensionsInches: {
            ...prev.dimensionsInches,
            [child]: value ? convertCmToInches(value) : "",
          },
        }));
      } else if (parent === "bedsheetDimensionsInches") {
        setVariantData((prev) => ({
          ...prev,
          bedsheetDimensionsInches: {
            ...prev.bedsheetDimensionsInches,
            [child]: value,
          },
        }));
      } else if (parent === "pillowCoverDimensionsInches") {
        setVariantData((prev) => ({
          ...prev,
          pillowCoverDimensionsInches: {
            ...prev.pillowCoverDimensionsInches,
            [child]: value,
          },
        }));
      }
    } else {
      setVariantData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleAddVariant = (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.stopPropagation();
      setValidatedvarient(true);
      return;
    }
    const {
      dimensionsInches,
      dimensionsCm,
      thickness,
      size,
      discountPercentage,
      price,
      _id,
      bedsheetDimensionsInches,
      pillowCoverDimensionsInches,
    } = variantData;
    const isPillow =
      formData.title.toLowerCase().includes("pillow") ||
      formData.subcategory.toLowerCase().includes("pillow");
    const isBedsheet = formData.subcategory.toLowerCase().includes("bedsheet");

    if (isBedsheet) {
      if (
        !bedsheetDimensionsInches.width ||
        !bedsheetDimensionsInches.length ||
        !bedsheetDimensionsInches.height ||
        !pillowCoverDimensionsInches.width ||
        !pillowCoverDimensionsInches.length ||
        !discountPercentage ||
        !price
      ) {
        setValidatedvarient(true);
        return;
      }
    } else {
      if (
        (!isPillow && !size) ||
        !dimensionsInches.width ||
        !dimensionsInches.height ||
        (isPillow && !dimensionsInches.length) ||
        !discountPercentage ||
        !price
      ) {
        setValidatedvarient(true);
        return;
      }
      if (!isPillow && !thickness) {
        setValidatedvarient(true);
        return;
      }
    }

    const newVariant = isBedsheet
      ? {
        _id: _id || null,
        thickness: "",
        size: "",
        // Encoded as "<bedsheet W>x<L>x<H>~<pillowCover W>x<L>" — a single
        // string keeps this compatible with the existing dimension_in
        // schema field without needing a backend/model change.
        dimension_in: `${bedsheetDimensionsInches.width}x${bedsheetDimensionsInches.length}x${bedsheetDimensionsInches.height}~${pillowCoverDimensionsInches.width}x${pillowCoverDimensionsInches.length}`,
        dimension_cm: "",
        discountPercentage,
        price,
      }
      : {
        _id: _id || null,
        thickness: isPillow ? "" : thickness,
        size: isPillow ? "" : size,
        dimension_in: isPillow
          ? `${dimensionsInches.width}x${dimensionsInches.height}x${dimensionsInches.length}`
          : `${dimensionsInches.width}x${dimensionsInches.height}`,
        dimension_cm: isPillow
          ? `${dimensionsCm.width}x${dimensionsCm.height}x${dimensionsCm.length}`
          : `${dimensionsCm.width}x${dimensionsCm.height}`,
        discountPercentage,
        price,
      };

    setFormData((prevFormData) => {
      let updatedVariants;
      if (editingIndex !== null) {
        updatedVariants = [...prevFormData.variants];
        updatedVariants[editingIndex] = newVariant;
      } else {
        updatedVariants = [...(prevFormData.variants || []), newVariant];
      }
      return { ...prevFormData, variants: updatedVariants };
    });

    setVariantPayload((prevPayload) => {
      let updatedPayload = [...prevPayload];
      const existingNewIndex = updatedPayload.findIndex(
        (entry) => entry.action === "new",
      );
      if (editingIndex !== null) {
        const isNewVariant = !newVariant._id;
        if (isNewVariant) {
          if (existingNewIndex !== -1) {
            const newVariants = updatedPayload[existingNewIndex].data
              .filter((item) => item !== null && item !== undefined)
              .map((item, idx) => (idx === editingIndex ? newVariant : item));
            updatedPayload[existingNewIndex] = {
              action: "new",
              data: newVariants,
            };
          } else {
            updatedPayload.push({ action: "new", data: [newVariant] });
          }
        } else {
          const existingModifiedIndex = updatedPayload.findIndex(
            (entry) => entry.action === "modified",
          );
          if (existingModifiedIndex !== -1) {
            const modifiedVariants = [
              ...updatedPayload[existingModifiedIndex].data,
            ];
            const variantIndex = modifiedVariants.findIndex(
              (v) => v._id === newVariant._id,
            );
            if (variantIndex !== -1) {
              modifiedVariants[variantIndex] = newVariant;
            } else {
              modifiedVariants.push(newVariant);
            }
            updatedPayload[existingModifiedIndex] = {
              action: "modified",
              data: modifiedVariants,
            };
          } else {
            updatedPayload.push({ action: "modified", data: [newVariant] });
          }
        }
      } else {
        if (existingNewIndex !== -1) {
          const newVariants = updatedPayload[existingNewIndex].data
            .filter((item) => item !== null && item !== undefined)
            .concat(newVariant);
          updatedPayload[existingNewIndex] = {
            action: "new",
            data: newVariants,
          };
        } else {
          updatedPayload.push({ action: "new", data: [newVariant] });
        }
      }
      return updatedPayload;
    });

    setVariantTable("block");
    setShowVarInput("none");
    setTxt(false);
    setValidatedvarient(false);
    setEditingIndex(null);
    const closeButton = document.querySelector(
      "#variant-modal [data-bs-dismiss='modal']",
    );
    if (closeButton) closeButton.click();
  };

  useEffect(() => {
    const modalElement = document.getElementById("variant-modal");
    const handleModalClose = () => {
      setVariantData({
        thickness: "",
        size: "",
        dimensionsInches: { width: "", height: "", length: "" },
        dimensionsCm: { width: "", height: "", length: "" },
        bedsheetDimensionsInches: { width: "", length: "", height: "" },
        pillowCoverDimensionsInches: { width: "", length: "" },
        discountPercentage: "",
        price: "",
        _id: null,
      });
      setEditingIndex(null);
      setTxt(false);
      setShowVarInput("none");
      setValidatedvarient(false);
    };
    modalElement.addEventListener("hidden.bs.modal", handleModalClose);
    return () =>
      modalElement.removeEventListener("hidden.bs.modal", handleModalClose);
  }, []);

  useEffect(() => {
    const modalElement = document.getElementById("color-modal");
    if (!modalElement) return;
    const handleModalClose = () => {
      setColorData({ colorName: "", colorCode: "#4A7043", images: [] });
      setEditingColorIndex(null);
      setColorValidated(false);
      if (colorImageInputRef.current) colorImageInputRef.current.value = "";
    };
    modalElement.addEventListener("hidden.bs.modal", handleModalClose);
    return () =>
      modalElement.removeEventListener("hidden.bs.modal", handleModalClose);
  }, []);

  const handleEditVariant = (index) => {
    const v = formData.variants[index];
    const isBedsheet = formData.subcategory.toLowerCase().includes("bedsheet");

    if (isBedsheet) {
      const [bedsheetPart, pillowPart] = (v.dimension_in || "").split("~");
      const [bW, bL, bH] = (bedsheetPart || "").split("x");
      const [pW, pL] = (pillowPart || "").split("x");
      setVariantData({
        _id: v._id || null,
        thickness: "",
        size: "",
        dimensionsInches: { width: "", height: "", length: "" },
        dimensionsCm: { width: "", height: "", length: "" },
        bedsheetDimensionsInches: {
          width: bW || "",
          length: bL || "",
          height: bH || "",
        },
        pillowCoverDimensionsInches: {
          width: pW || "",
          length: pL || "",
        },
        discountPercentage: v.discountPercentage,
        price: v.price,
      });
    } else {
      setVariantData({
        _id: v._id || null,
        thickness: v.thickness,
        size: v.size,
        dimensionsInches: {
          width: v.dimension_in?.split("x")[0] || "",
          height: v.dimension_in?.split("x")[1] || "",
          length: v.dimension_in?.split("x")[2] || "",
        },
        dimensionsCm: {
          width: v.dimension_cm?.split("x")[0] || "",
          height: v.dimension_cm?.split("x")[1] || "",
          length: v.dimension_cm?.split("x")[2] || "",
        },
        bedsheetDimensionsInches: { width: "", length: "", height: "" },
        pillowCoverDimensionsInches: { width: "", length: "" },
        discountPercentage: v.discountPercentage,
        price: v.price,
      });
    }
    setEditingIndex(index);
    setTxt(true);
    setShowVarInput("none");
  };

  const handleDeleteVariant = (index) => {
    setFormData((prevFormData) => {
      const deletedVariant = prevFormData.variants[index];
      const updatedVariants = prevFormData.variants.filter(
        (_, i) => i !== index,
      );
      if (updatedVariants.length === 0) setVariantTable("none");
      setVariantData({
        thickness: "",
        size: "",
        dimensionsInches: { width: "", height: "", length: "" },
        dimensionsCm: { width: "", height: "", length: "" },
        bedsheetDimensionsInches: { width: "", length: "", height: "" },
        pillowCoverDimensionsInches: { width: "", length: "" },
        discountPercentage: "",
        price: "",
      });
      setVariantPayload((prevPayload) => {
        let updatedPayload = [...prevPayload];
        const isNewVariant = !deletedVariant._id;
        if (isNewVariant) {
          const existingNewIndex = updatedPayload.findIndex(
            (entry) => entry.action === "new",
          );
          if (existingNewIndex !== -1) {
            const newVariants = updatedPayload[existingNewIndex].data
              .filter((_, i) => i !== index)
              .filter((item) => item !== null && item !== undefined);
            if (newVariants.length > 0) {
              updatedPayload[existingNewIndex] = {
                action: "new",
                data: newVariants,
              };
            } else {
              updatedPayload = updatedPayload.filter(
                (_, i) => i !== existingNewIndex,
              );
            }
          }
        } else {
          const actionIndex = updatedPayload.findIndex(
            (entry) => entry.action === "deleted",
          );
          if (actionIndex !== -1) {
            const updatedHistory = [...updatedPayload];
            updatedHistory[actionIndex].data.push(deletedVariant);
            updatedPayload = updatedHistory;
          } else {
            updatedPayload.push({ action: "deleted", data: [deletedVariant] });
          }
        }
        return updatedPayload;
      });
      return { ...prevFormData, variants: updatedVariants };
    });
  };

  // ─────────────────────────────────────────────
  // Cover handlers
  // ─────────────────────────────────────────────
  const handleCoverChange = (e) => {
    const { name, value } = e.target;
    setCoverData({ ...coverData, [name]: value });
  };

  /**
   * Queue the CURRENT cover image for GCP deletion if it's an existing
   * URL (not a File) and is about to be replaced with a new file. Both
   * the click-based upload and the drag/drop path funnel through this so
   * neither one can silently orphan a blob by overwriting coverData.image
   * without ever recording the old URL anywhere.
   */
  const queueOldCoverImageForDeletion = () => {
    if (coverData.image && !(coverData.image instanceof File)) {
      setFormData((prev) => ({
        ...prev,
        deleteCoverImageUrls: [
          ...(prev.deleteCoverImageUrls ?? []),
          coverData.image,
        ],
      }));
    }
  };

  const handleCoverFileUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      queueOldCoverImageForDeletion();
      const fileExtension = file.name.split(".").pop();
      const newFileName = coverData.name
        ? `${coverData.name}.${fileExtension}`
        : file.name;
      const renamedFile = new File([file], newFileName, {
        type: file.type,
        lastModified: file.lastModified,
      });
      setCoverData({ ...coverData, image: renamedFile });
    }
  };

  const handleCoverDrop = (e) => {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    if (file) {
      queueOldCoverImageForDeletion();
      const fileExtension = file.name.split(".").pop();
      const newFileName = coverData.name
        ? `${coverData.name}.${fileExtension}`
        : file.name;
      const renamedFile = new File([file], newFileName, {
        type: file.type,
        lastModified: file.lastModified,
      });
      setCoverData({ ...coverData, image: renamedFile });
    }
  };

  const handleCoverDragOver = (e) => e.preventDefault();

  const removeCoverImage = () => {
    // If it's an existing GCP URL, mark for deletion on save
    if (coverData.image && !(coverData.image instanceof File)) {
      setFormData((prev) => ({
        ...prev,
        deleteCoverImageUrls: [
          ...(prev.deleteCoverImageUrls ?? []),
          coverData.image,
        ],
      }));
    }
    setCoverData({ ...coverData, image: null });
  };

  const handleCoverFormSubmit = async (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.stopPropagation();
      setCoverValidated(true);
      return;
    }
    const newCover = {
      _id:
        coverData._id ||
        (editingCoverIndex !== null
          ? formData.covers[editingCoverIndex]?._id
          : null),
      name: coverData.name,
      notes: coverData.notes,
      description: coverData.description,
      image: coverData.image || null,
    };

    setFormData((prevFormData) => {
      if (editingCoverIndex !== null) {
        const updatedCovers = [...prevFormData.covers];
        updatedCovers[editingCoverIndex] = newCover;
        setCoverHistory((prevHistory) => {
          const actionIndex = prevHistory.findIndex(
            (entry) => entry.action === "modified",
          );
          if (actionIndex !== -1) {
            const updatedHistory = [...prevHistory];
            updatedHistory[actionIndex].data.push(newCover);
            return updatedHistory;
          }
          return [...prevHistory, { action: "modified", data: [newCover] }];
        });
        return { ...prevFormData, covers: updatedCovers };
      } else {
        const updatedCovers = [...(prevFormData.covers || []), newCover];
        setCoverHistory((prevHistory) => {
          const actionIndex = prevHistory.findIndex(
            (entry) => entry.action === "new",
          );
          if (actionIndex !== -1) {
            const updatedHistory = [...prevHistory];
            updatedHistory[actionIndex].data.push(newCover);
            return updatedHistory;
          }
          return [...prevHistory, { action: "new", data: [newCover] }];
        });
        return { ...prevFormData, covers: updatedCovers };
      }
    });

    setCoverData({ name: "", notes: "", description: "", image: null });
    setEditingCoverIndex(null);
    setCoverValidated(false);
    setCoverTable("block");
    const closeButton = document.querySelector(
      "#cover-modal [data-bs-dismiss='modal']",
    );
    if (closeButton) closeButton.click();
  };

  useEffect(() => {
    const modalElement = document.getElementById("cover-modal");
    const handleModalClose = () => {
      setCoverData({ name: "", notes: "", description: "", image: null });
      setEditingCoverIndex(null);
      setCoverValidated(false);
    };
    modalElement.addEventListener("hidden.bs.modal", handleModalClose);
    return () =>
      modalElement.removeEventListener("hidden.bs.modal", handleModalClose);
  }, []);

  const handleEditCover = (index) => {
    const coverToEdit = formData.covers[index];
    setCoverData({
      name: coverToEdit.name,
      notes: coverToEdit.notes,
      description: coverToEdit.description,
      image: coverToEdit.image,
      _id: coverToEdit._id || null,
    });
    setEditingCoverIndex(index);
  };

  const handleDeleteCover = (coverIdOrIndex) => {
    if (typeof coverIdOrIndex !== "number") return;
    setFormData((prevFormData) => {
      const deletedCover = prevFormData.covers[coverIdOrIndex];
      const updatedCovers = prevFormData.covers.filter(
        (_, index) => index !== coverIdOrIndex,
      );
      setCoverHistory((prevHistory) => {
        const actionIndex = prevHistory.findIndex(
          (entry) => entry.action === "deleted",
        );
        if (actionIndex !== -1) {
          const updatedHistory = [...prevHistory];
          updatedHistory[actionIndex].data.push(deletedCover);
          return updatedHistory;
        }
        return [...prevHistory, { action: "deleted", data: [deletedCover] }];
      });
      if (updatedCovers.length === 0) setCoverTable("none");
      return { ...prevFormData, covers: updatedCovers };
    });
  };

  // ─────────────────────────────────────────────
  // Product image handlers
  // ─────────────────────────────────────────────
  const handleImageChange = (event) => {
    const files = Array.from(event.target.files).filter((f) =>
      f.type.startsWith("image/"),
    );
    setFormData((prev) => ({
      ...prev,
      imageurl: [...prev.imageurl, ...files],
    }));
    setBcolor("#ccc");
  };

  const handleDrop = (event) => {
    event.preventDefault();
    const files = Array.from(event.dataTransfer.files).filter((f) =>
      f.type.startsWith("image/"),
    );
    setFormData((prev) => ({
      ...prev,
      imageurl: [...prev.imageurl, ...files],
    }));
  };

  const handleDragOver = (event) => event.preventDefault();

  /**
   * Delete an image from the imageurl array.
   * - If it's a File object (newly added, not yet uploaded): just remove it from the array.
   * - If it's a GCP URL string (existing image): add to deleteImageUrls so the backend removes it from GCP,
   *   then remove from the display array.
   */
  const handleDeleteImage = (index) => {
    setFormData((prevFormData) => {
      const imageToRemove = prevFormData.imageurl[index];
      const newDeleteImageUrls = prevFormData.deleteImageUrls
        ? [...prevFormData.deleteImageUrls]
        : [];

      // Only push to deleteImageUrls if it's an existing GCP URL (string), not a new File
      if (typeof imageToRemove === "string") {
        newDeleteImageUrls.push(imageToRemove);
      }

      const updatedImages = prevFormData.imageurl.filter((_, i) => i !== index);
      return {
        ...prevFormData,
        imageurl: updatedImages,
        deleteImageUrls: newDeleteImageUrls,
      };
    });
  };

  // ─────────────────────────────────────────────
  // Data loading
  // ─────────────────────────────────────────────
  const LoadCatSubCat = async () => {
    try {
      const response = await axios.get(baseUrl + "productdetails/allproducts");
      setData(response.data[0].products);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const extractCategories = (data) => {
    setCategories([...new Set(data.map((item) => item.category))]);
    setSubCategories([...new Set(data.map((item) => item.subcategory))]);
  };

  useEffect(() => {
    LoadCatSubCat();
  }, []);
  useEffect(() => {
    if (data.length > 0) extractCategories(data);
  }, [data]);

  const fetchVariants = () => {
    const allSizes = [];
    data.forEach((item) => {
      if (item.variants?.length > 0) {
        allSizes.push(
          ...item.variants
            .map((v) => v.size)
            .filter((s) => s && s.trim() !== ""),
        );
      }
    });
    setVarSize([...new Set(allSizes)]);
  };

  useEffect(() => {
    fetchVariants();
  }, [data]);

  // ─────────────────────────────────────────────
  // Submit
  // ─────────────────────────────────────────────
  const handleAddProduct = async (e) => {
    e.preventDefault();

    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.stopPropagation();
      setValidated(true);
      return;
    }

    // At least one image required — check both new Files and existing GCP URLs
    const hasImages = formData.imageurl.some(
      (img) => img instanceof File || typeof img === "string",
    );
    if (!hasImages) {
      setBcolor("red");
      return toast.warning("At least one product image is required");
    }
    setBcolor("#ccc");

    const formPayload = new FormData();

    // Serialize formData to JSON, replacing File objects with null
    const payload = JSON.parse(
      JSON.stringify(formData, (key, value) =>
        value instanceof File ? null : value,
      ),
    );
    // Always send category in lowercase to backend
    payload.category = payload.category
      ?.trim()
      .toLowerCase()
      .replace(/\s+/g, "-") || "";

    payload.subcategory = payload.subcategory
      ?.trim()
      .toLowerCase()
      .replace(/\s+/g, "-") || "";
      
    // Normalize mattress type
    if (!payload.mattressTypeInfo?.type?.trim()) {
      payload.mattressTypeInfo = null;
    }

    // ── Product Images: only append new File objects ──
    formData.imageurl.forEach((file) => {
      if (file instanceof File) formPayload.append("productImages", file);
    });

    // ── Feature Icons ──
    // Each new icon File is renamed to a unique "icon-<tabIdx>-<itemIdx>.<ext>"
    // filename before upload. Without this, two different items whose icon
    // files happened to share an original filename (e.g. both named
    // "icon.png") would collide in the backend's iconMap, and the second
    // upload would silently overwrite the first — causing both items to end
    // up pointing at the same (wrong) icon URL.
    formData.featureSection?.tabs?.forEach((tab, tIdx) => {
      tab.items?.forEach((item, iIdx) => {
        if (item.icon instanceof File) {
          const ext = item.icon.name.split(".").pop();
          const uniqueName = `icon-${tIdx}-${iIdx}.${ext}`;
          const renamedIcon = new File([item.icon], uniqueName, {
            type: item.icon.type,
            lastModified: item.icon.lastModified,
          });
          formPayload.append("featureIconImages", renamedIcon);
          payload.featureSection.tabs[tIdx].items[iIdx].icon = uniqueName;
        }
      });
    });

    // ── Feature Background ──
    if (formData.featureSection?.backgroundImage instanceof File) {
      formPayload.append(
        "featureBgImage",
        formData.featureSection.backgroundImage,
      );
      payload.featureSection.backgroundImage = null;
    }

    // ── Feature Mobile Background ──
    if (formData.featureSection?.mobileBackgroundImage instanceof File) {
      formPayload.append(
        "featureMobileBgImage",
        formData.featureSection.mobileBackgroundImage,
      );
      payload.featureSection.mobileBackgroundImage = null;
    }

    // ── Layer Images ──
    if (formData.layerSection?.layers?.length > 0) {
      formData.layerSection.layers.forEach((layer, lIdx) => {
        if (layer.image instanceof File) {
          const ext = layer.image.name.split(".").pop();
          const renamedFile = new File([layer.image], `layer-${lIdx}.${ext}`, {
            type: layer.image.type,
            lastModified: layer.image.lastModified,
          });
          formPayload.append("layerItemImages", renamedFile);
          if (payload.layerSection?.layers?.[lIdx]) {
            payload.layerSection.layers[lIdx].image = null;
          }
        }
        // Existing GCP URLs are already in payload.layerSection.layers[lIdx].image as strings
        // and will be preserved by the backend's applyLayerImageMap
      });
    }

    // ── Cover Images ──
    coverHistory.forEach((history) => {
      if (history.action === "new" || history.action === "modified") {
        history.data.forEach((cover) => {
          if (cover.image instanceof File) {
            formPayload.append("productCoverImages", cover.image);
          }
        });
      }
    });
    // ── Bedsheet Color Images ──
    // Rename each new File to "color-<colorKey>-<imgIndex>.<ext>" so the
    // backend can map the uploaded URL back to the right color/slot.
    // colorKey = existing color._id for "modified" colors, or "new-<index>"
    // for brand-new colors (which get a real _id assigned server-side).
    colorHistory.forEach((entry) => {
      if (entry.action === "new" || entry.action === "modified") {
        entry.data.forEach((color, cIdx) => {
          const colorKey =
            entry.action === "modified" ? color._id : `new-${cIdx}`;
          (color.images || []).forEach((file, iIdx) => {
            if (file instanceof File) {
              const ext = file.name.split(".").pop();
              const renamedFile = new File(
                [file],
                `color-${colorKey}-${iIdx}.${ext}`,
                { type: file.type, lastModified: file.lastModified },
              );
              formPayload.append("bedsheetColorImages", renamedFile);
            }
          });
        });
      }
    });
    // ── Variants payload ──
    payload.variants = variantPayload
      .map((entry) => ({
        action: entry.action,
        data: entry.data.filter(Boolean),
      }))
      .filter((entry) => entry.data.length > 0);

    // ── Covers payload: strip File objects, keep existing GCP URL strings ──
    payload.covers = coverHistory.map((entry) => ({
      ...entry,
      data: entry.data.map((cover) => ({
        ...cover,
        image: cover.image instanceof File ? null : cover.image,
      })),
    }));

    if (payload.layerSection) delete payload.layerSection.layerImage;
    payload.bedsheetType = formData.bedsheetType;
    // Action-based payload, same pattern as covers/variants. Strip Files
    // (they're uploaded separately) but keep existing GCP URL strings.
    payload.bedsheetColors = colorHistory
      .map((entry) => ({
        action: entry.action,
        data: entry.data.map((color) => ({
          ...color,
          images: (color.images || []).map((img) =>
            img instanceof File ? null : img,
          ),
        })),
      }))
      .filter((entry) => entry.data.length > 0);

    // deleteFeatureIconUrls / deleteFeatureBgUrls are already plain string
    // arrays on formData, so JSON.stringify above carried them into
    // `payload` automatically — nothing further to do here.

    formPayload.append("data", JSON.stringify(payload));

    const apiUrl = formData._id
      ? `${baseUrl}productdetails/${formData._id}`
      : `${baseUrl}productdetails/addingproducts`;

    setLoading(true);
    try {
      const response = await fetch(apiUrl, {
        method: formData._id ? "PUT" : "POST",
        body: formPayload,
      });
      const text = await response.text();
      if (!response.ok) {
        toast.error(JSON.parse(text)?.error || "Failed to save product");
      } else {
        toast.success(
          formData._id
            ? "Product updated successfully!"
            : "Product added successfully!",
        );
        resetAllFields();
        navigate("/All-products");
      }
    } catch (error) {
      toast.error("Server Error");
    } finally {
      setLoading(false);
    }
  };
  // Tag Input Handlers
  const handleTagKeyDown = (e, field) => {
    if (e.key === "Enter" || e.key === ",") {
      e.preventDefault();
      const value = e.target.value.trim();
      if (!value) return;

      setFormData((prev) => {
        const currentTags = prev[field] || [];
        if (!currentTags.includes(value)) {
          return { ...prev, [field]: [...currentTags, value] };
        }
        return prev;
      });

      e.target.value = "";
    }
  };

  const removeTag = (field, indexToRemove) => {
    setFormData((prev) => ({
      ...prev,
      [field]: (prev[field] || []).filter(
        (_, index) => index !== indexToRemove,
      ),
    }));
  };

  const addQuickTag = (field, value) => {
    setFormData((prev) => {
      const currentTags = prev[field] || [];
      if (!currentTags.includes(value)) {
        return { ...prev, [field]: [...currentTags, value] };
      }
      return prev;
    });
  };

  // ─────────────────────────────────────────────
  // Load product for editing
  // ─────────────────────────────────────────────
  useEffect(() => {
    if (location.state?.product) {
      const product = location.state.product;
      setFormData({
        title: product.title || "",
        seriesName: product.seriesName || "",
        tagline: product.tagline || "",
        description: product.description || "",
        // Load mattressTypeInfo correctly; fall back to empty object so controls stay controlled
        mattressTypeInfo: product.mattressTypeInfo || { type: "", tagline: "" },
        isBestSeller: product.isBestSeller || false, // NEW
        category: product.category || "",
        subcategory: product.subcategory || "",
        offerdescription: product.offerdescription || "",
        offercode: product.offercode || "",
        weight: product.weight || "",
        tags: product.tags || "",
        sku: product.sku || "",
        variants: product.variants || [],
        covers: product.covers || [],
        // Existing GCP URLs go directly into imageurl as strings — handleDeleteImage handles them
        imageurl: product.imageurl || [],
        deleteImageUrls: [],
        deleteCoverImageUrls: [],
        deleteLayerImageUrls: [],
        bedsheetColors: product.bedsheetColors || [],
        material: product.material || [],
        firmness: product.firmness || [],
        deleteColorImageUrls: [],
        deleteFeatureIconUrls: [],
        deleteFeatureBgUrls: [],
        _id: product._id || "",
        featureSection: product.featureSection || {
          mainTitle: "",
          mainDescription: "",
          backgroundImage: null,
          mobileBackgroundImage: null,
          tabs: [],
        },
        layerSection: product.layerSection
          ? {
            mainTitle: product.layerSection.mainTitle || "",
            mainDescription: product.layerSection.mainDescription || "",
            subDescription: product.layerSection.subDescription || "",
            layers: (product.layerSection.layers || []).map((l) => ({
              layerNumber: l.layerNumber,
              title: l.title,
              subtitle: l.subtitle,
              description: l.description,
              // Carry existing GCP URL so UI can preview and user can replace/remove
              image: l.image || null,
              _id: l._id,
            })),
          }
          : { mainTitle: "", mainDescription: "", layers: [] },
      });
      setIsEditing(true);
      setVariantPayload([]);
      setColorHistory([]);
      if (product.variants?.length > 0) setVariantTable("block");
      if (product.covers?.length > 0) setCoverTable("block");
    } else {
      setIsEditing(false);
      setVariantPayload([]);
    }
  }, [location.state]);

  const handleVarDropDown = (e) => {
    const { name, value } = e.target;
    if (name === "size" && value === "Add New") {
      setShowVarInput("block");
      setTxt(true);
      setValidatedvarient(false);
      setVariantData({ ...variantData, size: "" });
    } else if (name === "size") {
      setShowVarInput("none");
      setTxt(false);
      setValidatedvarient(false);
      setVariantData({ ...variantData, size: value });
    }
  };

  const handleNewSizeInputChange = (e) => {
    setVariantData((prev) => ({ ...prev, size: e.target.value }));
  };

  const handleMattressTypeChange = (e) => {
    const { value } = e.target;
    setFormData((prev) => ({
      ...prev,
      mattressTypeInfo: { ...prev.mattressTypeInfo, type: value },
    }));
  };

  const resetAllFields = () => {
    setFormData({
      title: "",
      seriesName: "",
      tagline: "",
      description: "",
      isBestSeller: false,
      mattressTypeInfo: { type: "", tagline: "" },
      category: "",
      subcategory: "",
      offerdescription: "",
      offercode: "",
      variants: [],
      covers: [],
      imageurl: [],
      deleteImageUrls: [],
      deleteCoverImageUrls: [],
      deleteLayerImageUrls: [],
      deleteColorImageUrls: [],
      deleteFeatureIconUrls: [],
      deleteFeatureBgUrls: [],
      bedsheetColors: [],
      bedsheetType: "",
      featureSection: {
        mainTitle: "",
        mainDescription: "",
        backgroundImage: null,
        mobileBackgroundImage: null,
        tabs: [],
      },
      layerSection: {
        mainTitle: "",
        mainDescription: "",
        subDescription: "",
        layers: [],
      },
    });
    setVariantPayload([]);
    setCoverHistory([]);
    setColorHistory([]);
    setDnewCat("none");
    setDnewSubCat("none");
    setShowVarInput("none");
    setCoverTable("none");
    setVariantTable("none");
    setBcolor("#ccc");
    setDisableCover(true);
    setValidated(false);
    setNewTab({ tabTitle: "", tabSubtitle: "" });
    setNewItem({ icon: null, title: "", description: "" });
    setEditingTabIndex(null);
    setEditingItemIndex(null);
    setCurrentTabIndex(null);
    setNewLayer({
      layerNumber: "",
      title: "",
      subtitle: "",
      description: "",
      image: null,
    });
    setEditingLayerIndex(null);
    if (bgImageInputRef.current) bgImageInputRef.current.value = "";
    if (mobileBgImageInputRef.current) mobileBgImageInputRef.current.value = "";
    if (itemIconInputRef.current) itemIconInputRef.current.value = "";
    if (isEditing) navigate("/All-products");
  };
  const isPillowSubcategory =
    formData.subcategory?.toLowerCase().includes("pillow") ||
    formData.subcategory?.toLowerCase().includes("bedsheet");

  // isMattressCategory: true only once a category has actually been
  // selected AND that category is a mattress-type category. Drives
  // visibility of the mattress-only fields (Series Name, Mattress Type,
  // Type Tagline, Material, Firmness) so they stay hidden until the user
  // has picked a category, and only ever show for mattress categories.
  // Adjust the match below if your DB stores an exact value like
  // "mattresses" rather than something merely containing "mattress".
  const isMattressCategory =
    !!formData.category && formData.category.toLowerCase().includes("mattress");

  // isPillowProduct: used ONLY to switch the Dimensions/Price layout in the
  // variant modal to the fixed, clearly-visible stacked inputs. Mattress
  // layout (input-group W/H boxes) is untouched.
  const isPillowProduct =
    formData.title.toLowerCase().includes("pillow") ||
    formData.subcategory.toLowerCase().includes("pillow");

  // isBedsheetProduct: switches the variant modal to the Bedsheet layout —
  // a Bedsheet Dimensions (In) W/L/H group plus a Pillow Cover Dimensions
  // (In) W/L group, followed by a single Price field. No Thickness, Size,
  // or Cm fields are shown for this subcategory.
  const isBedsheetProduct = formData.subcategory
    ?.toLowerCase()
    .includes("bedsheet");

  // ─────────────────────────────────────────────
  // Modal reset on close (Feature Tab / Item / Layer)
  // ─────────────────────────────────────────────
  useEffect(() => {
    const tabModal = document.getElementById("feature-tab-modal");
    const itemModal = document.getElementById("feature-item-modal");
    const layerModal = document.getElementById("layer-modal");

    const resetTab = () => {
      setNewTab({ tabTitle: "", tabSubtitle: "" });
      setEditingTabIndex(null);
    };
    const resetItem = () => {
      setNewItem({ icon: null, title: "", description: "" });
      setCurrentTabIndex(null);
      setEditingItemIndex(null);
      if (itemIconInputRef.current) itemIconInputRef.current.value = "";
    };
    const resetLayer = () => {
      setNewLayer({
        layerNumber: "",
        title: "",
        subtitle: "",
        description: "",
        image: null,
      });
      setEditingLayerIndex(null);
    };

    if (tabModal) tabModal.addEventListener("hidden.bs.modal", resetTab);
    if (itemModal) itemModal.addEventListener("hidden.bs.modal", resetItem);
    if (layerModal) layerModal.addEventListener("hidden.bs.modal", resetLayer);

    return () => {
      if (tabModal) tabModal.removeEventListener("hidden.bs.modal", resetTab);
      if (itemModal)
        itemModal.removeEventListener("hidden.bs.modal", resetItem);
      if (layerModal)
        layerModal.removeEventListener("hidden.bs.modal", resetLayer);
    };
  }, []);

  // ─────────────────────────────────────────────
  // Render
  // ─────────────────────────────────────────────
  return (
    <div>
      {Loading ? (
        <div className="relative h-[100vh] flex items-center justify-center">
          <RotatingLines
            visible={true}
            height="150"
            width="150"
            strokeColor="#24425a"
            strokeWidth="5"
            animationDuration="0.75"
            ariaLabel="rotating-lines-loading"
          />
        </div>
      ) : (
        <div>
          <div className="product-details">
            <Container fluid>
              <div className="row mt-3 mb-2">
                <div className="col-6">
                  <h5>
                    <Link to="/">Products</Link> /{" "}
                    <span className="text-[15px] font-normal">
                      {isEditing ? "Update Product" : "Add Product"}
                    </span>
                  </h5>
                </div>
                <div className="col-6 flex justify-between">
                  <div></div>
                  <div>
                    <Button
                      variant="primary"
                      type="button"
                      onClick={handleAddProduct}
                      className="add-product-btn w-28"
                    >
                      Save
                    </Button>
                    <button
                      type="button"
                      className="w-28 btn btn-primary mx-2"
                      onClick={() => {
                        resetAllFields();
                        setValidated(false);
                      }}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>

              <Form
                noValidate
                validated={validated}
                onSubmit={handleAddProduct}
              >
                <div className="">
                  <Row>
                    {/* ── Left Column ── */}
                    <Col lg={6} className="prodInfo me-3">
                      <div>
                        <h5>Product Details</h5>
                        <hr />
                        <Form.Group className="mt-3">
                          <div className="row flex justify-between items-center">
                            <div className="col-2">
                              <Form.Label className="font-medium">
                                Title
                              </Form.Label>
                            </div>
                            <div className="col-10">
                              <Form.Control
                                type="text"
                                name="title"
                                required
                                value={formData.title}
                                onChange={handleChange}
                                placeholder="Product title"
                              />
                            </div>
                          </div>
                        </Form.Group>

                        <Form.Group className="mt-3">
                          <div className="row">
                            <div className="col-2">
                              <Form.Label>Tagline</Form.Label>
                            </div>
                            <div className="col-10">
                              <Form.Control
                                type="text"
                                name="tagline"
                                value={formData.tagline}
                                onChange={handleChange}
                                placeholder="Short catchy tagline"
                              />
                            </div>
                          </div>
                        </Form.Group>

                        <Form.Group className="mt-2">
                          <div className="row flex justify-center items-center">
                            <div className="col-2">
                              <Form.Label className="font-medium">
                                Description
                              </Form.Label>
                            </div>
                            <div className="col-10">
                              <Form.Control
                                as="textarea"
                                name="description"
                                required
                                value={formData.description}
                                onChange={handleChange}
                                placeholder="Product Description"
                                className="description-textarea"
                                style={{
                                  height: "auto",
                                  whiteSpace: "pre-wrap",
                                  paddingTop: "15px",
                                  lineHeight: "15px",
                                }}
                              />
                            </div>
                          </div>
                        </Form.Group>

                        <div className="mt-2">
                          <h5>Images</h5>
                        </div>
                        <hr className="mb-[-10px]" />
                        <Row>
                          <Col>
                            <div
                              className="preview-images flex flex-row gap-3 flex-wrap w-full h-48 overflow-y-auto"
                              id="image-container"
                            >
                              {formData.imageurl.map((image, index) => (
                                <div
                                  key={index}
                                  className="preview-container mt-3 position-relative"
                                >
                                  <img
                                    src={
                                      image instanceof File
                                        ? URL.createObjectURL(image)
                                        : image // existing GCP URL renders directly
                                    }
                                    alt="Uploaded Preview"
                                    style={{
                                      width: "165px",
                                      height: "160px",
                                      objectFit: "cover",
                                      borderRadius: "10px",
                                    }}
                                  />
                                  {/* Delete button works for both new Files and existing GCP URLs */}
                                  <FontAwesomeIcon
                                    icon={faTimes}
                                    className="position-absolute top-0 end-0 p-1"
                                    style={{
                                      cursor: "pointer",
                                      color: "red",
                                      backgroundColor: "black",
                                      fontSize: "1.2rem",
                                    }}
                                    onClick={() => handleDeleteImage(index)}
                                  />
                                </div>
                              ))}
                            </div>
                          </Col>
                        </Row>

                        <Form.Group className="flex flex-col mb-2">
                          <div
                            className="file-upload"
                            onClick={() =>
                              document
                                .getElementById("media-file-input")
                                .click()
                            }
                            onDrop={handleDrop}
                            onDragOver={handleDragOver}
                            style={{
                              width: "100%",
                              height: "40px",
                              border: `2px dashed ${bColor}`,
                              borderRadius: "10px",
                              textAlign: "center",
                              paddingTop: "5px",
                              cursor: "pointer",
                              backgroundColor: "rgb(248 250 253)",
                            }}
                          >
                            <span className="font-medium">
                              Drag and drop your file here
                            </span>
                            <Form.Control
                              type="file"
                              accept="image/*"
                              multiple
                              required
                              style={{ display: "none" }}
                              id="media-file-input"
                              onChange={handleImageChange}
                            />
                            <span className="mx-2">or</span>
                            <span className="bi bi-file-earmark-arrow-up font-medium"></span>
                          </div>
                        </Form.Group>

                        {/* Variant Modal */}
                        <Row className="mt-5 mb-5">
                          <div className="modal fade" id="variant-modal">
                            <div className="modal-dialog modal-dialog-centered">
                              <div className="modal-content">
                                <div className="p-4 modal-header">
                                  <h3 className="font-medium text-[blue]">
                                    Variants
                                  </h3>
                                  <button
                                    type="button"
                                    className="btn-close"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                  ></button>
                                </div>
                                <div className="modal-body">
                                  <Form
                                    noValidate
                                    validated={validatedvarient}
                                    onSubmit={handleAddVariant}
                                  >
                                    <Form.Group
                                      controlId="thickness"
                                      className={`mb-3 flex justify-between ${isPillowProduct || isBedsheetProduct
                                        ? "d-none"
                                        : "d-block"
                                        }`}
                                    >
                                      <div className="row w-100">
                                        <div className="col-4">
                                          <Form.Label className="font-medium">
                                            Thickness (In)
                                          </Form.Label>
                                        </div>
                                        <div className="col-8">
                                          <Form.Control
                                            type="number"
                                            placeholder="Enter thickness"
                                            name="thickness"
                                            required={
                                              !isPillowProduct &&
                                              !isBedsheetProduct
                                            }
                                            value={variantData.thickness}
                                            onChange={handleChangeVariants}
                                          />
                                        </div>
                                      </div>
                                    </Form.Group>

                                    {!isPillowProduct && !isBedsheetProduct && (
                                      <Form.Group
                                        controlId="size"
                                        className="mb-3 flex justify-between"
                                      >
                                        <div className="row w-100">
                                          <div className="col-4 flex justify-start items-center">
                                            <Form.Label className="font-medium">
                                              Size
                                            </Form.Label>
                                          </div>
                                          <div className="col-8">
                                            <div
                                              className={`row flex justify-center items-center ${txt ? "mt-[-30px] mb-[-10px]" : ""}`}
                                            >
                                              <div
                                                className={
                                                  txt ? "col-6" : "col-12"
                                                }
                                              >
                                                <select
                                                  className="form-select py-2"
                                                  name="size"
                                                  required
                                                  onChange={handleVarDropDown}
                                                  value={variantData.size || ""}
                                                >
                                                  {(!variantData.size ||
                                                    txt) && (
                                                      <option value="" disabled>
                                                        Select Size
                                                      </option>
                                                    )}
                                                  {varSize.map(
                                                    (item, index) => (
                                                      <option
                                                        key={index}
                                                        value={item}
                                                      >
                                                        {item}
                                                      </option>
                                                    ),
                                                  )}
                                                  <option value="Add New">
                                                    Add New
                                                  </option>
                                                </select>
                                              </div>
                                              <div className="col-6">
                                                <div
                                                  className={`d-${showVarInput} my-3`}
                                                >
                                                  <input
                                                    className="form-control"
                                                    type="text"
                                                    required
                                                    placeholder="Add New Size"
                                                    value={variantData.size}
                                                    onChange={
                                                      handleNewSizeInputChange
                                                    }
                                                    name="size"
                                                  />
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </Form.Group>
                                    )}

                                    {/* ── Dimensions (In) ──
                                        Bedsheet: two stacked groups —
                                        Bedsheet W/L/H and Pillow Cover W/L,
                                        no Cm fields. Pillow: stacked layout
                                        with a Length field. Mattress:
                                        original input-group layout,
                                        unchanged. */}
                                    <Form.Group
                                      controlId="dimensions"
                                      className="mb-3 flex justify-between"
                                    >
                                      {isBedsheetProduct ? (
                                        <div className="w-100">
                                          <Form.Label className="font-medium d-block mb-2">
                                            Bedsheet – Dimensions (In)
                                          </Form.Label>
                                          <div className="d-flex gap-3 mb-3">
                                            <div className="flex-fill">
                                              <Form.Label className="small text-muted mb-1">
                                                Width
                                              </Form.Label>
                                              <Form.Control
                                                type="number"
                                                required
                                                name="bedsheetDimensionsInches.width"
                                                value={
                                                  variantData
                                                    .bedsheetDimensionsInches
                                                    .width
                                                }
                                                onChange={handleChangeVariants}
                                                style={{
                                                  color: "#000",
                                                  backgroundColor: "#fff",
                                                }}
                                              />
                                            </div>
                                            <div className="flex-fill">
                                              <Form.Label className="small text-muted mb-1">
                                                Length
                                              </Form.Label>
                                              <Form.Control
                                                type="number"
                                                required
                                                name="bedsheetDimensionsInches.length"
                                                value={
                                                  variantData
                                                    .bedsheetDimensionsInches
                                                    .length
                                                }
                                                onChange={handleChangeVariants}
                                                style={{
                                                  color: "#000",
                                                  backgroundColor: "#fff",
                                                }}
                                              />
                                            </div>
                                            <div className="flex-fill">
                                              <Form.Label className="small text-muted mb-1">
                                                Height
                                              </Form.Label>
                                              <Form.Control
                                                type="number"
                                                required
                                                name="bedsheetDimensionsInches.height"
                                                value={
                                                  variantData
                                                    .bedsheetDimensionsInches
                                                    .height
                                                }
                                                onChange={handleChangeVariants}
                                                style={{
                                                  color: "#000",
                                                  backgroundColor: "#fff",
                                                }}
                                              />
                                            </div>
                                          </div>

                                          <Form.Label className="font-medium d-block mb-2">
                                            Pillow Cover – Dimensions (In)
                                          </Form.Label>
                                          <div className="d-flex gap-3">
                                            <div className="flex-fill">
                                              <Form.Label className="small text-muted mb-1">
                                                Width
                                              </Form.Label>
                                              <Form.Control
                                                type="number"
                                                required
                                                name="pillowCoverDimensionsInches.width"
                                                value={
                                                  variantData
                                                    .pillowCoverDimensionsInches
                                                    .width
                                                }
                                                onChange={handleChangeVariants}
                                                style={{
                                                  color: "#000",
                                                  backgroundColor: "#fff",
                                                }}
                                              />
                                            </div>
                                            <div className="flex-fill">
                                              <Form.Label className="small text-muted mb-1">
                                                Length
                                              </Form.Label>
                                              <Form.Control
                                                type="number"
                                                required
                                                name="pillowCoverDimensionsInches.length"
                                                value={
                                                  variantData
                                                    .pillowCoverDimensionsInches
                                                    .length
                                                }
                                                onChange={handleChangeVariants}
                                                style={{
                                                  color: "#000",
                                                  backgroundColor: "#fff",
                                                }}
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      ) : isPillowProduct ? (
                                        <div className="w-100">
                                          <Form.Label className="font-medium d-block mb-2">
                                            Dimensions (In)
                                          </Form.Label>
                                          <div className="d-flex gap-3">
                                            <div className="flex-fill">
                                              <Form.Label className="small text-muted mb-1">
                                                Width
                                              </Form.Label>
                                              <Form.Control
                                                type="number"
                                                required
                                                name="dimensionsInches.width"
                                                value={
                                                  variantData.dimensionsInches
                                                    .width
                                                }
                                                onChange={handleChangeVariants}
                                                style={{
                                                  color: "#000",
                                                  backgroundColor: "#fff",
                                                }}
                                              />
                                            </div>
                                            <div className="flex-fill">
                                              <Form.Label className="small text-muted mb-1">
                                                Height
                                              </Form.Label>
                                              <Form.Control
                                                type="number"
                                                required
                                                name="dimensionsInches.height"
                                                value={
                                                  variantData.dimensionsInches
                                                    .height
                                                }
                                                onChange={handleChangeVariants}
                                                style={{
                                                  color: "#000",
                                                  backgroundColor: "#fff",
                                                }}
                                              />
                                            </div>
                                            <div className="flex-fill">
                                              <Form.Label className="small text-muted mb-1">
                                                Length
                                              </Form.Label>
                                              <Form.Control
                                                type="number"
                                                required
                                                name="dimensionsInches.length"
                                                value={
                                                  variantData.dimensionsInches
                                                    .length
                                                }
                                                onChange={handleChangeVariants}
                                                style={{
                                                  color: "#000",
                                                  backgroundColor: "#fff",
                                                }}
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      ) : (
                                        <div className="row w-100">
                                          <div className="col-4">
                                            <Form.Label>
                                              Dimensions (In)
                                            </Form.Label>
                                          </div>
                                          <div className="col-8 p-0">
                                            <div className="row p-0 m-0 w-100">
                                              <div className="col-5">
                                                <div className="input-group">
                                                  <span className="input-group-text font-medium">
                                                    W
                                                  </span>
                                                  <input
                                                    className="form-control px-2"
                                                    type="number"
                                                    required
                                                    name="dimensionsInches.width"
                                                    value={
                                                      variantData
                                                        .dimensionsInches.width
                                                    }
                                                    onChange={
                                                      handleChangeVariants
                                                    }
                                                  />
                                                </div>
                                              </div>
                                              <div className="col-2 p-0 flex justify-center items-center">
                                                <p className="font-medium">*</p>
                                              </div>
                                              <div className="col-5">
                                                <div className="input-group">
                                                  <span className="input-group-text font-medium">
                                                    H
                                                  </span>
                                                  <input
                                                    className="form-control px-2"
                                                    type="number"
                                                    required
                                                    name="dimensionsInches.height"
                                                    value={
                                                      variantData
                                                        .dimensionsInches.height
                                                    }
                                                    onChange={
                                                      handleChangeVariants
                                                    }
                                                  />
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      )}
                                    </Form.Group>

                                    {/* ── Dimensions (Cm) ──
                                        Hidden entirely for Bedsheet variants
                                        (Bedsheet layout only uses inches).
                                        Same pillow/mattress split as before
                                        otherwise. */}
                                    {!isBedsheetProduct && (
                                      <Form.Group
                                        controlId="dimensionsCm"
                                        className="mb-3 flex justify-between"
                                      >
                                        {isPillowProduct ? (
                                          <div className="w-100">
                                            <Form.Label className="font-medium d-block mb-2">
                                              Dimensions (Cm)
                                            </Form.Label>
                                            <div className="d-flex gap-3">
                                              <div className="flex-fill">
                                                <Form.Label className="small text-muted mb-1">
                                                  Width
                                                </Form.Label>
                                                <Form.Control
                                                  type="number"
                                                  required
                                                  name="dimensionsCm.width"
                                                  value={
                                                    variantData.dimensionsCm
                                                      .width
                                                  }
                                                  onChange={
                                                    handleChangeVariants
                                                  }
                                                  style={{
                                                    color: "#000",
                                                    backgroundColor: "#fff",
                                                  }}
                                                />
                                              </div>
                                              <div className="flex-fill">
                                                <Form.Label className="small text-muted mb-1">
                                                  Height
                                                </Form.Label>
                                                <Form.Control
                                                  type="number"
                                                  required
                                                  name="dimensionsCm.height"
                                                  value={
                                                    variantData.dimensionsCm
                                                      .height
                                                  }
                                                  onChange={
                                                    handleChangeVariants
                                                  }
                                                  style={{
                                                    color: "#000",
                                                    backgroundColor: "#fff",
                                                  }}
                                                />
                                              </div>
                                              <div className="flex-fill">
                                                <Form.Label className="small text-muted mb-1">
                                                  Length
                                                </Form.Label>
                                                <Form.Control
                                                  type="number"
                                                  required
                                                  name="dimensionsCm.length"
                                                  value={
                                                    variantData.dimensionsCm
                                                      .length
                                                  }
                                                  onChange={
                                                    handleChangeVariants
                                                  }
                                                  style={{
                                                    color: "#000",
                                                    backgroundColor: "#fff",
                                                  }}
                                                />
                                              </div>
                                            </div>
                                          </div>
                                        ) : (
                                          <div className="row w-100">
                                            <div className="col-4">
                                              <Form.Label className="font-medium">
                                                Dimensions (Cm)
                                              </Form.Label>
                                            </div>
                                            <div className="col-8 p-0">
                                              <div className="row w-100 p-0 m-0">
                                                <div className="col-5">
                                                  <div className="input-group">
                                                    <span className="input-group-text font-medium">
                                                      W
                                                    </span>
                                                    <input
                                                      className="form-control px-2"
                                                      type="number"
                                                      required
                                                      name="dimensionsCm.width"
                                                      value={
                                                        variantData.dimensionsCm
                                                          .width
                                                      }
                                                      onChange={
                                                        handleChangeVariants
                                                      }
                                                    />
                                                  </div>
                                                </div>
                                                <div className="col-2 flex p-0 justify-center items-center">
                                                  <p className="font-medium">
                                                    *
                                                  </p>
                                                </div>
                                                <div className="col-5">
                                                  <div className="input-group">
                                                    <span className="input-group-text">
                                                      H
                                                    </span>
                                                    <input
                                                      className="form-control px-2"
                                                      type="number"
                                                      required
                                                      name="dimensionsCm.height"
                                                      value={
                                                        variantData.dimensionsCm
                                                          .height
                                                      }
                                                      onChange={
                                                        handleChangeVariants
                                                      }
                                                    />
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        )}
                                      </Form.Group>
                                    )}
                                    {/* ── discountPercentage ──
                                        Bedsheet & pillow share the wide
                                        stacked layout; mattress keeps its
                                        narrow layout. */}
                                    <Form.Group
                                      controlId="discountPercentage"
                                      className="mb-3 flex justify-between"
                                    >
                                      {isPillowProduct || isBedsheetProduct ? (
                                        <div className="w-100">
                                          <Form.Label className="font-medium d-block mb-2">
                                            Discount Percentage
                                          </Form.Label>
                                          <Form.Control
                                            type="number"
                                            placeholder="Enter Discount Percentage Value"
                                            name="discountPercentage"
                                            required
                                            value={variantData.discountPercentage}
                                            onChange={handleChangeVariants}
                                            style={{
                                              color: "#000",
                                              backgroundColor: "#fff",
                                              fontSize: "1rem",
                                            }}
                                          />
                                        </div>
                                      ) : (
                                        <div className="row w-100">
                                          <div className="col-4">
                                            <Form.Label className="font-medium">
                                              Discount Percentage
                                            </Form.Label>
                                          </div>
                                          <div className="col-8">
                                            <Form.Control
                                              type="number"
                                              placeholder="Enter Discount Percentage Value"
                                              name="discountPercentage"
                                              required
                                              value={variantData.discountPercentage}
                                              onChange={handleChangeVariants}
                                            />
                                          </div>
                                        </div>
                                      )}
                                    </Form.Group>
                                    {/* ── Price ──
                                        Bedsheet & pillow share the wide
                                        stacked layout; mattress keeps its
                                        narrow layout. */}
                                    <Form.Group
                                      controlId="price"
                                      className="mb-3 flex justify-between"
                                    >
                                      {isPillowProduct || isBedsheetProduct ? (
                                        <div className="w-100">
                                          <Form.Label className="font-medium d-block mb-2">
                                            Price
                                          </Form.Label>
                                          <Form.Control
                                            type="number"
                                            placeholder="Enter price"
                                            name="price"
                                            required
                                            value={variantData.price}
                                            onChange={handleChangeVariants}
                                            style={{
                                              color: "#000",
                                              backgroundColor: "#fff",
                                              fontSize: "1rem",
                                            }}
                                          />
                                        </div>
                                      ) : (
                                        <div className="row w-100">
                                          <div className="col-4">
                                            <Form.Label className="font-medium">
                                              Price
                                            </Form.Label>
                                          </div>
                                          <div className="col-8">
                                            <Form.Control
                                              type="number"
                                              placeholder="Enter price"
                                              name="price"
                                              required
                                              value={variantData.price}
                                              onChange={handleChangeVariants}
                                            />
                                          </div>
                                        </div>
                                      )}
                                    </Form.Group>

                                    <div className="flex justify-center mt-4 mb-2">
                                      <Button
                                        variant="primary"
                                        onClick={handleAddVariant}
                                        type="button"
                                      >
                                        {editingIndex !== null
                                          ? "Update"
                                          : "Save"}
                                      </Button>
                                    </div>
                                  </Form>
                                </div>
                              </div>
                            </div>
                          </div>
                        </Row>
                      </div>

                      <div className="my-4">
                        <Button
                          type="button"
                          data-bs-toggle="modal"
                          data-bs-target="#variant-modal"
                          onClick={() => {
                            setValidated(false);
                            setValidatedvarient(false);
                            setVariantData({
                              thickness: "",
                              size: "",
                              dimensionsInches: {
                                width: "",
                                height: "",
                                length: "",
                              },
                              dimensionsCm: {
                                width: "",
                                height: "",
                                length: "",
                              },
                              bedsheetDimensionsInches: {
                                width: "",
                                length: "",
                                height: "",
                              },
                              pillowCoverDimensionsInches: {
                                width: "",
                                length: "",
                              },
                              discountPercentage: "",
                              price: "",
                              _id: null,
                            });
                            setEditingIndex(null);
                            setTxt(false);
                            setShowVarInput("none");
                          }}
                          className="mr-5 mt-2"
                          style={{
                            display:
                              formData.category && formData.subcategory
                                ? "inline-block"
                                : "none",
                          }}
                        >
                          Add Variant
                        </Button>
                      </div>

                      <Row
                        style={{ marginTop: "20px" }}
                        className={`mt-16 pb-10 d-${variantTable} mx-2 h-52 overflow-y-auto`}
                      >
                        <h3 className="bg-primary py-.5 sticky top-0 mb-[-2px] text-white">
                          Variants
                        </h3>
                        <table>
                          <thead className="border-b-2 sticky top-[34px]">
                            <tr className="bg-dark text-white">
                              <th className="text-sm text-center">#</th>
                              {!isPillowProduct && !isBedsheetProduct && (
                                <th className="text-sm text-center">
                                  Thickness (In)
                                </th>
                              )}
                              {!isPillowProduct && !isBedsheetProduct && (
                                <th className="text-sm text-center">Size</th>
                              )}
                              {isBedsheetProduct ? (
                                <>
                                  <th className="text-sm text-center">
                                    Bedsheet Dimn (In)
                                  </th>
                                  <th className="text-sm text-center">
                                    Pillow Cover Dimn (In)
                                  </th>
                                </>
                              ) : (
                                <th className="text-center">
                                  <span className="text-sm">
                                    Dimn (In | Cm)
                                  </span>
                                </th>
                              )}
                              <th className="text-sm text-center">Discount Percentage</th>
                              <th className="text-sm text-center">Price</th>
                              <th className="text-sm text-center">Actions</th>
                            </tr>
                          </thead>
                          <tbody>
                            {(formData.variants || []).map((variant, index) => {
                              const [bedsheetDimn, pillowCoverDimn] = (
                                variant.dimension_in || ""
                              ).split("~");
                              return (
                                <tr key={index} className="border-b-2 my-1 p-5">
                                  <td className="text-center">{index + 1}.</td>
                                  {!isPillowProduct && !isBedsheetProduct && (
                                    <td className="text-sm text-center">
                                      {variant.thickness}
                                    </td>
                                  )}
                                  {!isPillowProduct && !isBedsheetProduct && (
                                    <td className="text-sm text-center">
                                      {variant.size}
                                    </td>
                                  )}
                                  {isBedsheetProduct ? (
                                    <>
                                      <td className="text-center">
                                        {bedsheetDimn}
                                      </td>
                                      <td className="text-center">
                                        {pillowCoverDimn}
                                      </td>
                                    </>
                                  ) : (
                                    <td className="text-center">
                                      {variant.dimension_in}{" "}
                                      <span className="font-bold"> | </span>{" "}
                                      {variant.dimension_cm}
                                    </td>
                                  )}
                                  <td className="text-center">
                                    {/* <span className="font-medium">₹ </span> */}
                                    {variant.discountPercentage || 0}
                                  </td>
                                  <td className="text-center">
                                    <span className="font-medium">₹ </span>
                                    {variant.price}
                                  </td>
                                  <td className="text-center gap-6 actions">
                                    <button
                                      type="button"
                                      data-bs-toggle="modal"
                                      data-bs-target="#variant-modal"
                                      onClick={() => handleEditVariant(index)}
                                    >
                                      <span
                                        className="bi bi-pen text-[green]"
                                        title="Edit Variant"
                                      ></span>
                                    </button>{" "}
                                    <button
                                      type="button"
                                      onClick={() => handleDeleteVariant(index)}
                                    >
                                      <span
                                        className="bi bi-trash text-[red]"
                                        title="Delete"
                                      ></span>
                                    </button>
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </Row>
                    </Col>

                    {/* ── Right Column ── */}
                    <Col lg={5} className="prodInfo pb-10">
                      <div className="">
                        {/* Category */}
                        <div className="row flex justify-center items-center mt-2">
                          <div className="col-3">
                            <Form.Label className="font-medium pt-1.5">
                              Category
                            </Form.Label>
                          </div>
                          <div className="col-9">
                            <select
                              className="form-select capitalize"
                              name="categoryDropdown"
                              required
                              value={formData.category}
                              onChange={handleCategoryChange}
                              disabled={isEditing}
                            >
                              <option value="" disabled>
                                Select Categories
                              </option>
                              {categories.map((item, index) => (
                                <option
                                  key={index}
                                  value={item}
                                  className="capitalize"
                                >
                                  {item}
                                </option>
                              ))}
                              <option value="Add New Category">Add New</option>
                            </select>
                            <div className={`d-${dnewCat} my-2 mt-3`}>
                              <input
                                className="form-control"
                                type="text"
                                required
                                name="categoryInput"
                                onChange={handleCategoryChange}
                                placeholder="Add New"
                              />
                            </div>
                          </div>
                        </div>

                        {/* Sub Category */}
                        <div className="row mt-3">
                          <div className="col-3">
                            <Form.Label className="font-medium pt-1.5">
                              Sub Category
                            </Form.Label>
                          </div>
                          <div className="col-9">
                            <select
                              className="form-select capitalize"
                              required
                              value={formData.subcategory}
                              onChange={handleSubCategoryChange}
                              disabled={isEditing}
                            >
                              <option value="" disabled>
                                Select Subcategories
                              </option>
                              {subCategories.map((item, index) => (
                                <option
                                  key={index}
                                  value={item}
                                  className="capitalize"
                                >
                                  {item}
                                </option>
                              ))}
                              <option value="Add New">Add New</option>
                            </select>
                            {dnewSubCat === "block" && (
                              <div className="my-2 mt-3">
                                <input
                                  required
                                  className="form-control"
                                  type="text"
                                  name="subcategory"
                                  onChange={handleNewSubCategoryInput}
                                  placeholder="Add New"
                                />
                              </div>
                            )}
                          </div>
                        </div>

                        {/* Weight */}
                        <Form.Group className="mt-3">
                          <div className="row flex justify-center items-center">
                            <div className="col-3">
                              <Form.Label className="font-medium">
                                Weight
                              </Form.Label>
                            </div>
                            <div className="col-9">
                              <Form.Control
                                name="weight"
                                required
                                type="number"
                                value={formData.weight}
                                onChange={handleChange}
                                placeholder="Total Weight in Kgs"
                              />
                            </div>
                          </div>
                        </Form.Group>
                        {/* Best Seller */}
                        <Form.Group className="mt-3">
                          <div className="row flex justify-center items-center">
                            <div className="col-3">
                              <Form.Label className="font-medium">
                                Best Seller
                              </Form.Label>
                            </div>
                            <div className="col-9">
                              <Form.Check
                                type="switch"
                                id="best-seller-switch"
                                checked={formData.isBestSeller}
                                onChange={handleBestSellerChange}
                                label={formData.isBestSeller ? "Yes" : "No"}
                              />
                            </div>
                          </div>
                        </Form.Group>
                        {/* Offer Code */}
                        <Form.Group className="mt-2">
                          <div className="row flex justify-center items-center">
                            <div className="col-3">
                              <Form.Label className="font-medium">
                                Offer Code
                              </Form.Label>
                            </div>
                            <div className="col-9">
                              <Form.Control
                                name="offercode"
                                value={formData.offercode}
                                onChange={handleChange}
                                placeholder="Offer Code"
                              />
                            </div>
                          </div>
                        </Form.Group>

                        {/* Offer Description */}
                        <Form.Group className="mt-2 mb-3">
                          <div className="row flex justify-center items-center">
                            <div className="col-3">
                              <Form.Label className="font-medium">
                                Offer Description
                              </Form.Label>
                            </div>
                            <div className="col-9">
                              <Form.Control
                                as="textarea"
                                name="offerdescription"
                                value={formData.offerdescription}
                                onChange={handleChange}
                                placeholder="Offers"
                                style={{
                                  height: "auto",
                                  whiteSpace: "pre-wrap",
                                  paddingTop: "15px",
                                  lineHeight: "15px",
                                }}
                              />
                            </div>
                          </div>
                        </Form.Group>

                        {/* Mattress-only fields — only shown once a
                            category is selected AND it's a mattress
                            category (isMattressCategory). Previously
                            gated on !isPillowSubcategory (subcategory
                            based), now gated on category selection. */}
                        {isMattressCategory && (
                          <Form.Group className="mt-3">
                            <div className="row flex justify-between items-center">
                              <div className="col-3">
                                <Form.Label className="font-medium">
                                  Series Name
                                </Form.Label>
                              </div>
                              <div className="col-9">
                                <Form.Control
                                  type="text"
                                  name="seriesName"
                                  value={formData.seriesName}
                                  onChange={handleChange}
                                  placeholder="e.g. Mellow Soft Series"
                                  required
                                />
                              </div>
                            </div>
                          </Form.Group>
                        )}

                        {isMattressCategory && (
                          <Form.Group className="mt-3">
                            <div className="row flex justify-between items-center">
                              <div className="col-3">
                                <Form.Label className="font-medium">
                                  Mattress Type
                                </Form.Label>
                              </div>
                              <div className="col-9">
                                <select
                                  className="form-select"
                                  value={formData.mattressTypeInfo?.type || ""}
                                  onChange={handleMattressTypeChange}
                                >
                                  <option value="">Select Type</option>
                                  <option value="Standard">Standard</option>
                                  <option value="Duo">Duo</option>
                                </select>
                              </div>
                            </div>
                          </Form.Group>
                        )}

                        {isMattressCategory && (
                          <Form.Group className="mt-2">
                            <div className="row flex justify-between items-center">
                              <div className="col-3">
                                <Form.Label className="font-medium">
                                  Type Tagline
                                </Form.Label>
                              </div>
                              <div className="col-9">
                                <Form.Control
                                  type="text"
                                  placeholder="For those who love sinking into rest"
                                  value={
                                    formData.mattressTypeInfo?.tagline || ""
                                  }
                                  onChange={(e) =>
                                    setFormData((prev) => ({
                                      ...prev,
                                      mattressTypeInfo: {
                                        ...prev.mattressTypeInfo,
                                        tagline: e.target.value,
                                      },
                                    }))
                                  }
                                />
                              </div>
                            </div>
                          </Form.Group>
                        )}

                        {/* Material Field — mattress-only, category gated */}
                        {isMattressCategory && (
                          <div className="row mt-3">
                            <div className="col-3">
                              <Form.Label className="font-medium pt-1.5">
                                Material
                              </Form.Label>
                            </div>
                            <div className="col-9">
                              <div className="border rounded p-2 min-h-[50px] flex flex-wrap gap-2 bg-white mb-2">
                                {(formData.material || []).map((tag, index) => (
                                  <div
                                    key={index}
                                    className="bg-[#24425a] text-white px-3 py-1 rounded-full flex items-center gap-2 text-sm"
                                  >
                                    {tag}
                                    <button
                                      type="button"
                                      onClick={() =>
                                        removeTag("material", index)
                                      }
                                      className="text-white hover:text-red-300 font-bold"
                                    >
                                      ×
                                    </button>
                                  </div>
                                ))}
                                <input
                                  type="text"
                                  className="flex-1 border-0 focus:outline-none px-2 py-1 min-w-[140px]"
                                  placeholder="Type and press Enter"
                                  onKeyDown={(e) =>
                                    handleTagKeyDown(e, "material")
                                  }
                                />
                              </div>

                              {/* Quick Add Buttons */}
                              <div className="flex flex-wrap gap-2">
                                {[
                                  "Latex",
                                  "Ortho",
                                  "Memory Foam",
                                  "Foam",
                                  "Coir",
                                ].map((item) => (
                                  <button
                                    key={item}
                                    type="button"
                                    onClick={() =>
                                      addQuickTag("material", item)
                                    }
                                    className="text-xs px-3 py-1 border border-gray-300 hover:bg-gray-100 rounded-full transition"
                                  >
                                    + {item}
                                  </button>
                                ))}
                              </div>
                            </div>
                          </div>
                        )}

                        {/* Firmness Field — mattress-only, category gated */}
                        {isMattressCategory && (
                          <div className="row mt-3">
                            <div className="col-3">
                              <Form.Label className="font-medium pt-1.5">
                                Firmness
                              </Form.Label>
                            </div>
                            <div className="col-9">
                              <div className="border rounded p-2 min-h-[50px] flex flex-wrap gap-2 bg-white mb-2">
                                {(formData.firmness || []).map((tag, index) => (
                                  <div
                                    key={index}
                                    className="bg-[#24425a] text-white px-3 py-1 rounded-full flex items-center gap-2 text-sm"
                                  >
                                    {tag}
                                    <button
                                      type="button"
                                      onClick={() =>
                                        removeTag("firmness", index)
                                      }
                                      className="text-white hover:text-red-300 font-bold"
                                    >
                                      ×
                                    </button>
                                  </div>
                                ))}
                                <input
                                  type="text"
                                  className="flex-1 border-0 focus:outline-none px-2 py-1 min-w-[140px]"
                                  placeholder="Type and press Enter"
                                  onKeyDown={(e) =>
                                    handleTagKeyDown(e, "firmness")
                                  }
                                />
                              </div>

                              {/* Quick Add Buttons */}
                              <div className="flex flex-wrap gap-2">
                                {["Soft", "Medium", "Firm", "Extra Firm"].map(
                                  (item) => (
                                    <button
                                      key={item}
                                      type="button"
                                      onClick={() =>
                                        addQuickTag("firmness", item)
                                      }
                                      className="text-xs px-3 py-1 border border-gray-300 hover:bg-gray-100 rounded-full transition"
                                    >
                                      + {item}
                                    </button>
                                  ),
                                )}
                              </div>
                            </div>
                          </div>
                        )}
                        {formData.subcategory
                          ?.toLowerCase()
                          .includes("bedsheet") && (
                            <>
                              <div className="row mt-3">
                                <div className="col-3">
                                  <Form.Label className="font-medium">
                                    Bedsheet Type
                                  </Form.Label>
                                </div>
                                <div className="col-9">
                                  <select
                                    className="form-select"
                                    value={formData.bedsheetType || ""}
                                    onChange={(e) =>
                                      setFormData((prev) => ({
                                        ...prev,
                                        bedsheetType: e.target.value,
                                      }))
                                    }
                                  >
                                    <option value="">Select Type</option>
                                    <option value="flat">Flat</option>
                                    <option value="fitted">Fitted</option>
                                  </select>
                                </div>
                              </div>

                              {/* Color Manager */}
                              <div className="mt-4">
                                <h5>Bedsheet Colors</h5>
                                <Button
                                  type="button"
                                  variant="success"
                                  data-bs-toggle="modal"
                                  data-bs-target="#color-modal"
                                  onClick={() => {
                                    setColorValidated(false);
                                    setColorData({
                                      colorName: "",
                                      colorCode: "#4A7043",
                                      images: [],
                                    });
                                    setEditingColorIndex(null);
                                    if (colorImageInputRef.current)
                                      colorImageInputRef.current.value = "";
                                  }}
                                >
                                  + Add Color
                                </Button>

                                {/* Color List */}
                                <Row className="mt-3">
                                  {(formData.bedsheetColors || []).map(
                                    (color, idx) => (
                                      <Col
                                        md={4}
                                        key={color._id || idx}
                                        className="mb-3"
                                      >
                                        <Card>
                                          <Card.Body>
                                            <div
                                              style={{
                                                background: color.colorCode,
                                                height: 60,
                                                borderRadius: 8,
                                              }}
                                            />
                                            <strong className="d-block mt-2">
                                              {color.colorName}
                                            </strong>
                                            <p className="mb-2 small text-muted">
                                              {color.images?.length || 0} image(s)
                                            </p>
                                            <div className="d-flex gap-2 flex-wrap mb-2">
                                              {(color.images || [])
                                                .slice(0, 3)
                                                .map((img, i) => (
                                                  <img
                                                    key={i}
                                                    src={
                                                      img instanceof File
                                                        ? URL.createObjectURL(img)
                                                        : img
                                                    }
                                                    alt={`${color.colorName} ${i}`}
                                                    style={{
                                                      width: 40,
                                                      height: 40,
                                                      objectFit: "cover",
                                                      borderRadius: 4,
                                                    }}
                                                  />
                                                ))}
                                            </div>
                                            <div className="d-flex gap-3">
                                              <button
                                                type="button"
                                                data-bs-toggle="modal"
                                                data-bs-target="#color-modal"
                                                onClick={() =>
                                                  handleEditColor(idx)
                                                }
                                              >
                                                <span
                                                  className="bi bi-pen text-[green]"
                                                  title="Edit Color"
                                                ></span>
                                              </button>
                                              <button
                                                type="button"
                                                onClick={() =>
                                                  handleDeleteColor(idx)
                                                }
                                              >
                                                <span
                                                  className="bi bi-trash text-[red]"
                                                  title="Delete Color"
                                                ></span>
                                              </button>
                                            </div>
                                          </Card.Body>
                                        </Card>
                                      </Col>
                                    ),
                                  )}
                                </Row>
                              </div>

                              {/* Color Modal */}
                              <div className="modal fade" id="color-modal">
                                <div className="modal-dialog modal-dialog-centered modal-md">
                                  <div className="modal-content">
                                    <div className="modal-header">
                                      <h3 className="font-medium text-[blue]">
                                        Bedsheet Color
                                      </h3>
                                      <button
                                        type="button"
                                        className="btn btn-close"
                                        data-bs-dismiss="modal"
                                        aria-label="Close"
                                      ></button>
                                    </div>
                                    <div className="modal-body pb-5">
                                      <Form
                                        noValidate
                                        validated={colorValidated}
                                        onSubmit={handleColorFormSubmit}
                                      >
                                        <Form.Group className="mb-3">
                                          <Form.Label className="font-medium">
                                            Color Name
                                          </Form.Label>
                                          <Form.Control
                                            type="text"
                                            required
                                            placeholder="e.g. Juniper Green"
                                            name="colorName"
                                            value={colorData.colorName}
                                            onChange={handleColorChange}
                                          />
                                        </Form.Group>

                                        <Form.Group className="mb-3">
                                          <Form.Label className="font-medium">
                                            Color
                                          </Form.Label>
                                          <div className="d-flex align-items-center gap-2">
                                            <Form.Control
                                              type="color"
                                              name="colorCode"
                                              value={colorData.colorCode}
                                              onChange={handleColorChange}
                                              style={{
                                                width: "60px",
                                                height: "38px",
                                                padding: "2px",
                                              }}
                                            />
                                            <Form.Control
                                              type="text"
                                              name="colorCode"
                                              value={colorData.colorCode}
                                              onChange={handleColorChange}
                                              placeholder="#4A7043"
                                            />
                                          </div>
                                        </Form.Group>

                                        <div className="mb-3">
                                          <h5 className="font-medium">
                                            Color Images
                                          </h5>
                                        </div>
                                        <div className="preview-images mb-3 d-flex flex-wrap gap-2">
                                          {colorData.images.map(
                                            (image, index) => (
                                              <div
                                                key={index}
                                                className="preview-container position-relative"
                                                style={{ padding: "5px" }}
                                              >
                                                <img
                                                  src={
                                                    image instanceof File
                                                      ? URL.createObjectURL(image)
                                                      : image
                                                  }
                                                  alt="Color Preview"
                                                  style={{
                                                    width: "90px",
                                                    height: "90px",
                                                    objectFit: "cover",
                                                    borderRadius: "10px",
                                                  }}
                                                />
                                                <FontAwesomeIcon
                                                  icon={faTimes}
                                                  className="position-absolute top-0 end-0 p-1"
                                                  style={{
                                                    cursor: "pointer",
                                                    color: "red",
                                                    fontSize: "1rem",
                                                    backgroundColor: "black",
                                                    borderRadius: "4px",
                                                  }}
                                                  onClick={() =>
                                                    removeColorImage(index)
                                                  }
                                                />
                                              </div>
                                            ),
                                          )}
                                        </div>
                                        <Form.Group>
                                          <div
                                            className="file-upload flex justify-center items-center gap-2"
                                            onClick={() =>
                                              document
                                                .getElementById(
                                                  "color-file-input",
                                                )
                                                .click()
                                            }
                                            onDragOver={handleColorDragOver}
                                            onDrop={handleColorDrop}
                                            style={{
                                              width: "100%",
                                              height: "40px",
                                              border: `2px dashed ${bColor}`,
                                              borderRadius: "10px",
                                              textAlign: "center",
                                              cursor: "pointer",
                                              backgroundColor:
                                                "rgb(248, 250, 253)",
                                            }}
                                          >
                                            <span>
                                              Drag and drop your file(s) here
                                            </span>
                                            <input
                                              type="file"
                                              accept="image/*"
                                              multiple
                                              ref={colorImageInputRef}
                                              style={{ display: "none" }}
                                              id="color-file-input"
                                              onChange={handleColorFileUpload}
                                            />
                                            <span>or</span>
                                            <span className="bi-file-earmark-arrow-up"></span>
                                          </div>
                                        </Form.Group>
                                        <div className="flex justify-center mt-5">
                                          <Button
                                            type="button"
                                            className="py-2 px-4 rounded-md text-white bg-[#24425a] mt-3"
                                            onClick={handleColorFormSubmit}
                                          >
                                            {editingColorIndex !== null
                                              ? "Update Color"
                                              : "Save Color"}
                                          </Button>
                                        </div>
                                      </Form>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </>
                          )}
                        {/* Cover Modal */}
                        <div className="modal fade" id="cover-modal">
                          <div className="modal-dialog modal-dialog-centered modal-md">
                            <div className="modal-content">
                              <div className="modal-header">
                                <h3 className="font-medium text-[blue]">
                                  Cover Information
                                </h3>
                                <button
                                  type="button"
                                  className="btn btn-close"
                                  data-bs-dismiss="modal"
                                  aria-label="Close"
                                ></button>
                              </div>
                              <div className="modal-body pb-5">
                                <Form
                                  noValidate
                                  validated={coverValidated}
                                  onSubmit={handleCoverFormSubmit}
                                >
                                  <Form.Group className="mb-3">
                                    <Form.Label className="font-medium">
                                      Cover Name
                                    </Form.Label>
                                    <Form.Control
                                      type="text"
                                      required
                                      placeholder="Enter cover name"
                                      name="name"
                                      value={coverData.name}
                                      onChange={handleCoverChange}
                                    />
                                  </Form.Group>
                                  <Form.Group className="mb-3">
                                    <Form.Label className="font-medium">
                                      Cover Note
                                    </Form.Label>
                                    <Form.Control
                                      type="text"
                                      required
                                      placeholder="Enter cover note"
                                      name="notes"
                                      value={coverData.notes}
                                      onChange={handleCoverChange}
                                    />
                                  </Form.Group>
                                  <Form.Group className="mb-3">
                                    <Form.Label className="font-medium">
                                      Description
                                    </Form.Label>
                                    <Form.Control
                                      as="textarea"
                                      required
                                      placeholder="Enter description"
                                      name="description"
                                      value={coverData.description}
                                      onChange={handleCoverChange}
                                      style={{
                                        height: "60px",
                                        whiteSpace: "pre-wrap",
                                        paddingTop: "10px",
                                        lineHeight: "1.5",
                                      }}
                                    />
                                  </Form.Group>
                                  <div className="mb-4">
                                    <h5 className="font-medium">Cover Image</h5>
                                  </div>
                                  <div className="preview-images mb-4">
                                    {coverData.image && (
                                      <div
                                        className="preview-container position-relative"
                                        style={{
                                          display: "inline-block",
                                          marginRight: "5px",
                                          marginLeft: "10px",
                                          padding: "5px",
                                        }}
                                      >
                                        <img
                                          src={
                                            coverData.image instanceof File
                                              ? URL.createObjectURL(
                                                coverData.image,
                                              )
                                              : coverData.image
                                          }
                                          alt="Uploaded Preview"
                                          style={{
                                            width: "200px",
                                            height: "200px",
                                            objectFit: "cover",
                                            borderRadius: "10px",
                                          }}
                                        />
                                        <FontAwesomeIcon
                                          icon={faTimes}
                                          className="position-absolute top-5 end-0 p-1"
                                          style={{
                                            cursor: "pointer",
                                            color: "red",
                                            fontSize: "1.3rem",
                                            marginTop: "-12px",
                                            marginRight: "8px",
                                            backgroundColor: "black",
                                            borderRadius: "4px",
                                          }}
                                          onClick={removeCoverImage}
                                        />
                                      </div>
                                    )}
                                  </div>
                                  <Form.Group>
                                    <div
                                      className="file-upload flex justify-center items-center gap-2"
                                      onClick={() =>
                                        document
                                          .getElementById("cover-file-input")
                                          .click()
                                      }
                                      onDragOver={handleCoverDragOver}
                                      onDrop={handleCoverDrop}
                                      style={{
                                        width: "100%",
                                        height: "40px",
                                        border: `2px dashed ${bColor}`,
                                        borderRadius: "10px",
                                        textAlign: "center",
                                        cursor: "pointer",
                                        backgroundColor: "rgb(248, 250, 253)",
                                      }}
                                    >
                                      <span>Drag and drop your file here</span>
                                      <input
                                        type="file"
                                        accept="image/*"
                                        style={{ display: "none" }}
                                        id="cover-file-input"
                                        onChange={handleCoverFileUpload}
                                      />
                                      <span>or</span>
                                      <span className="bi-file-earmark-arrow-up"></span>
                                    </div>
                                  </Form.Group>
                                  <div className="flex justify-center mt-5">
                                    <Button
                                      type="button"
                                      className="py-2 px-4 rounded-md text-white bg-[#24425a] mt-3"
                                      onClick={handleCoverFormSubmit}
                                    >
                                      {editingCoverIndex !== null
                                        ? "Update Cover"
                                        : "Save Cover"}
                                    </Button>
                                  </div>
                                </Form>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      {formData.category &&
                        formData.category &&
                        formData.category === "mattresses" && (
                          <Button
                            type="button"
                            className="btn btn-primary w-28 mt-6 mb-3"
                            data-bs-toggle="modal"
                            data-bs-target="#cover-modal"
                            onClick={() => {
                              setValidated(false);
                              setCoverValidated(false);
                            }}
                          >
                            Add Cover
                          </Button>
                        )}

                      <Row
                        className={`d-${coverTable} mx-2 mt-2 flex justify-center h-52 overflow-y-auto`}
                      >
                        <h3 className="bg-primary py-1 sticky top-0 mb-[-3px] text-white">
                          Covers
                        </h3>
                        <table>
                          <thead className="sticky top-[40px]">
                            <tr className="border-b-2 mt-2 bg-dark">
                              <th className="text-sm text-center text-white">
                                #
                              </th>
                              <th className="text-sm text-center text-white">
                                Cover Name
                              </th>
                              <th className="text-sm text-center text-white">
                                Cover Note
                              </th>
                              <th className="text-sm text-center text-white">
                                Cover Description
                              </th>
                              <th className="text-sm text-center text-white">
                                Actions
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {(formData.covers || []).map((cover, index) => (
                              <tr key={index} className="border-b-2 my-1">
                                <td className="text-center">{index + 1}.</td>
                                <td
                                  className="text-center ellipsis"
                                  title={cover.name}
                                >
                                  {cover.name}
                                </td>
                                <td
                                  className="text-center ellipsis"
                                  title={cover.notes}
                                >
                                  {cover.notes}
                                </td>
                                <td
                                  className="text-center ellipsis"
                                  title={cover.description}
                                >
                                  {cover.description}
                                </td>
                                <td className="flex justify-center items-center gap-2 actions">
                                  <button
                                    type="button"
                                    data-bs-target="#cover-modal"
                                    data-bs-toggle="modal"
                                    onClick={() => handleEditCover(index)}
                                  >
                                    <span
                                      className="bi bi-pen text-[green]"
                                      title="Edit Cover"
                                    ></span>
                                  </button>
                                  <button
                                    type="button"
                                    onClick={() => handleDeleteCover(index)}
                                  >
                                    <span className="bi bi-trash text-[red]"></span>
                                  </button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </Row>
                    </Col>
                  </Row>
                </div>

                {/* ── Feature & Layer Sections ── */}
                <Row>
                  <Col xs={12}>
                    {/* ══ Feature Section ══ */}
                    <div className="mt-4 p-3 border rounded bg-light">
                      <h5>Feature Section</h5>

                      <Form.Group className="mt-2">
                        <Form.Label>Main Title</Form.Label>
                        <Form.Control
                          type="text"
                          value={formData.featureSection.mainTitle || ""}
                          onChange={(e) =>
                            handleFeatureChange("mainTitle", e.target.value)
                          }
                          placeholder="Quality, Sustainability & Health"
                        />
                      </Form.Group>

                      <Form.Group className="mt-2">
                        <Form.Label>Main Description</Form.Label>
                        <Form.Control
                          as="textarea"
                          rows={3}
                          value={formData.featureSection.mainDescription || ""}
                          onChange={(e) =>
                            handleFeatureChange(
                              "mainDescription",
                              e.target.value,
                            )
                          }
                        />
                      </Form.Group>

                      {/* Background Image */}
                      <Form.Group className="mt-3">
                        <Form.Label>Background Image</Form.Label>
                        {formData.featureSection.backgroundImage && (
                          <div className="mb-2 position-relative d-inline-block">
                            <img
                              src={
                                formData.featureSection
                                  .backgroundImage instanceof File
                                  ? URL.createObjectURL(
                                    formData.featureSection.backgroundImage,
                                  )
                                  : formData.featureSection.backgroundImage
                              }
                              alt="BG Preview"
                              style={{
                                maxHeight: "100px",
                                borderRadius: "6px",
                                display: "block",
                              }}
                            />
                            <button
                              type="button"
                              className="position-absolute top-0 end-0 m-1 btn btn-sm p-0"
                              onClick={() => {
                                setFeatureBgField("backgroundImage", null);
                                if (bgImageInputRef.current)
                                  bgImageInputRef.current.value = "";
                              }}
                            >
                              <FontAwesomeIcon
                                icon={faTimes}
                                style={{
                                  color: "red",
                                  backgroundColor: "black",
                                  borderRadius: "3px",
                                  padding: "2px",
                                  fontSize: "1rem",
                                }}
                              />
                            </button>
                          </div>
                        )}
                        <Form.Control
                          type="file"
                          accept="image/*"
                          ref={bgImageInputRef}
                          onChange={(e) => {
                            if (e.target.files[0])
                              setFeatureBgField(
                                "backgroundImage",
                                e.target.files[0],
                              );
                          }}
                        />
                      </Form.Group>

                      {/* Mobile Background Image */}
                      <Form.Group className="mt-3">
                        <Form.Label>Mobile Background Image</Form.Label>
                        {formData.featureSection.mobileBackgroundImage && (
                          <div className="mb-2 position-relative d-inline-block">
                            <img
                              src={
                                formData.featureSection
                                  .mobileBackgroundImage instanceof File
                                  ? URL.createObjectURL(
                                    formData.featureSection
                                      .mobileBackgroundImage,
                                  )
                                  : formData.featureSection
                                    .mobileBackgroundImage
                              }
                              alt="Mobile BG Preview"
                              style={{
                                maxHeight: "100px",
                                borderRadius: "6px",
                                display: "block",
                              }}
                            />
                            <button
                              type="button"
                              className="position-absolute top-0 end-0 m-1 btn btn-sm p-0"
                              onClick={() => {
                                setFeatureBgField(
                                  "mobileBackgroundImage",
                                  null,
                                );
                                if (mobileBgImageInputRef.current)
                                  mobileBgImageInputRef.current.value = "";
                              }}
                            >
                              <FontAwesomeIcon
                                icon={faTimes}
                                style={{
                                  color: "red",
                                  backgroundColor: "black",
                                  borderRadius: "3px",
                                  padding: "2px",
                                  fontSize: "1rem",
                                }}
                              />
                            </button>
                          </div>
                        )}
                        <Form.Control
                          type="file"
                          accept="image/*"
                          ref={mobileBgImageInputRef}
                          onChange={(e) => {
                            if (e.target.files[0])
                              setFeatureBgField(
                                "mobileBackgroundImage",
                                e.target.files[0],
                              );
                          }}
                        />
                      </Form.Group>

                      <hr className="my-3" />
                      <div className="d-flex justify-content-between align-items-center mb-2">
                        <h6 className="mb-0">Tabs &amp; Items</h6>
                        <Button
                          type="button"
                          variant="success"
                          size="sm"
                          data-bs-toggle="modal"
                          data-bs-target="#feature-tab-modal"
                          onClick={() => {
                            setNewTab({ tabTitle: "", tabSubtitle: "" });
                            setEditingTabIndex(null);
                          }}
                        >
                          + Add Tab
                        </Button>
                      </div>

                      {/* Render Tabs */}
                      {(formData.featureSection.tabs || []).map(
                        (tab, tabIndex) => (
                          <Card key={tabIndex} className="mb-3">
                            <Card.Header className="d-flex justify-content-between align-items-center">
                              <div>
                                <strong>{tab.tabTitle}</strong>
                                {tab.tabSubtitle && (
                                  <div className="text-muted small mt-1">
                                    {tab.tabSubtitle}
                                  </div>
                                )}
                              </div>
                              <div className="d-flex align-items-center gap-3">
                                <button
                                  type="button"
                                  className="btn btn-sm btn-link p-0"
                                  data-bs-toggle="modal"
                                  data-bs-target="#feature-tab-modal"
                                  onClick={() => handleEditTab(tabIndex)}
                                >
                                  <span
                                    className="bi bi-pen text-[green]"
                                    title="Edit Tab"
                                  ></span>
                                </button>
                                <button
                                  type="button"
                                  className="btn btn-sm btn-link text-danger p-0"
                                  onClick={(e) => removeTab(e, tabIndex)}
                                >
                                  <FontAwesomeIcon icon={faTimes} />
                                </button>
                              </div>
                            </Card.Header>
                            <Card.Body>
                              {tab.items.map((item, itemIndex) => (
                                <div
                                  key={itemIndex}
                                  className="border p-3 mb-3 rounded position-relative"
                                >
                                  <div className="position-absolute top-0 end-0 m-2 d-flex gap-3">
                                    <button
                                      type="button"
                                      className="btn btn-sm btn-link p-0"
                                      data-bs-toggle="modal"
                                      data-bs-target="#feature-item-modal"
                                      onClick={() =>
                                        handleEditItem(tabIndex, itemIndex)
                                      }
                                    >
                                      <span
                                        className="bi bi-pen text-[green]"
                                        title="Edit Item"
                                      ></span>
                                    </button>
                                    <button
                                      type="button"
                                      className="btn btn-sm btn-link text-danger p-0"
                                      onClick={(e) =>
                                        removeItem(e, tabIndex, itemIndex)
                                      }
                                    >
                                      <FontAwesomeIcon icon={faTimes} />
                                    </button>
                                  </div>
                                  {item.icon && (
                                    <div className="mb-2">
                                      <img
                                        src={
                                          item.icon instanceof File
                                            ? URL.createObjectURL(item.icon)
                                            : item.icon // existing GCP URL
                                        }
                                        alt="Icon"
                                        style={{
                                          width: "60px",
                                          height: "60px",
                                          objectFit: "cover",
                                          borderRadius: "8px",
                                        }}
                                      />
                                    </div>
                                  )}
                                  <strong>{item.title}</strong>
                                  <p className="small text-muted mt-1">
                                    {item.description}
                                  </p>
                                </div>
                              ))}

                              {/* Add Item Trigger */}
                              <div className="mt-3 border-top pt-3 text-center">
                                <Button
                                  type="button"
                                  size="sm"
                                  variant="primary"
                                  data-bs-toggle="modal"
                                  data-bs-target="#feature-item-modal"
                                  onClick={() => {
                                    setCurrentTabIndex(tabIndex);
                                    setEditingItemIndex(null);
                                    setNewItem({
                                      icon: null,
                                      title: "",
                                      description: "",
                                    });
                                    if (itemIconInputRef.current)
                                      itemIconInputRef.current.value = "";
                                  }}
                                >
                                  + Add Item
                                </Button>
                              </div>
                            </Card.Body>
                          </Card>
                        ),
                      )}
                    </div>

                    {/* ══ Layer Section ══ */}
                    {!isPillowSubcategory && (
                      <div className="mt-4 p-3 border rounded bg-light">
                        <h5>Layer Section</h5>

                        <Form.Group className="mt-2">
                          <Form.Label>Main Title</Form.Label>
                          <Form.Control
                            type="text"
                            value={formData.layerSection.mainTitle || ""}
                            onChange={(e) =>
                              handleLayerChange("mainTitle", e.target.value)
                            }
                            placeholder="Every layer crafted with care"
                          />
                        </Form.Group>

                        <Form.Group className="mt-2">
                          <Form.Label>Main Description</Form.Label>
                          <Form.Control
                            as="textarea"
                            rows={3}
                            value={formData.layerSection.mainDescription || ""}
                            onChange={(e) =>
                              handleLayerChange(
                                "mainDescription",
                                e.target.value,
                              )
                            }
                            placeholder="Every night brings better sleep..."
                          />
                        </Form.Group>
                        <Form.Group className="mt-2">
                          <Form.Label>Sub Description</Form.Label>
                          <Form.Control
                            as="textarea"
                            rows={3}
                            value={formData.layerSection.subDescription || ""}
                            onChange={(e) =>
                              handleLayerChange(
                                "subDescription",
                                e.target.value,
                              )
                            }
                            placeholder="Every night brings better sleep..."
                          />
                        </Form.Group>

                        <hr className="my-3" />
                        <div className="d-flex justify-content-between align-items-center mb-2">
                          <h6 className="mb-0">Layers</h6>
                          <Button
                            type="button"
                            variant="primary"
                            size="sm"
                            data-bs-toggle="modal"
                            data-bs-target="#layer-modal"
                            onClick={() => {
                              setNewLayer({
                                layerNumber: "",
                                title: "",
                                subtitle: "",
                                description: "",
                                image: null,
                              });
                              setEditingLayerIndex(null);
                            }}
                          >
                            + Add Layer
                          </Button>
                        </div>

                        {/* Existing / Added Layers */}
                        {(formData.layerSection.layers || []).map(
                          (layer, index) => (
                            <div
                              key={layer._id || index}
                              className="border p-3 rounded mb-2 position-relative"
                            >
                              <div className="position-absolute top-0 end-0 m-2 d-flex gap-3">
                                <button
                                  type="button"
                                  className="btn btn-sm btn-link p-0"
                                  data-bs-toggle="modal"
                                  data-bs-target="#layer-modal"
                                  onClick={() => handleEditLayer(index)}
                                >
                                  <span
                                    className="bi bi-pen text-[green]"
                                    title="Edit Layer"
                                  ></span>
                                </button>
                                <button
                                  type="button"
                                  className="btn btn-sm btn-link text-danger p-0"
                                  onClick={(e) => removeLayer(e, index)}
                                >
                                  <FontAwesomeIcon icon={faTimes} />
                                </button>
                              </div>

                              <h6>
                                Layer {layer.layerNumber} — {layer.title}
                              </h6>
                              {layer.subtitle && (
                                <p className="text-muted mb-1">
                                  <strong>{layer.subtitle}</strong>
                                </p>
                              )}
                              <p className="small mb-2">{layer.description}</p>

                              {/* Layer Image Preview (read-only here, edit via modal) */}
                              {layer.image && (
                                <div className="mb-1">
                                  <img
                                    src={
                                      layer.image instanceof File
                                        ? URL.createObjectURL(layer.image)
                                        : layer.image // existing GCP URL renders directly
                                    }
                                    alt={`Layer ${layer.layerNumber} preview`}
                                    style={{
                                      maxHeight: "100px",
                                      maxWidth: "160px",
                                      borderRadius: "6px",
                                      display: "block",
                                      objectFit: "cover",
                                    }}
                                  />
                                </div>
                              )}
                            </div>
                          ),
                        )}
                      </div>
                    )}
                  </Col>
                </Row>

                {/* ══ Feature Tab Modal (Add / Edit) ══ */}
                <div className="modal fade" id="feature-tab-modal">
                  <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                      <div className="modal-header">
                        <h5 className="modal-title">
                          {editingTabIndex !== null ? "Edit Tab" : "Add Tab"}
                        </h5>
                        <button
                          type="button"
                          className="btn-close"
                          data-bs-dismiss="modal"
                          aria-label="Close"
                        ></button>
                      </div>
                      <div className="modal-body">
                        <Form.Group className="mb-2">
                          <Form.Label className="font-medium">
                            Tab Title
                          </Form.Label>
                          <Form.Control
                            placeholder="Tab Title (e.g. Quality)"
                            value={newTab.tabTitle}
                            onChange={(e) =>
                              setNewTab((prev) => ({
                                ...prev,
                                tabTitle: e.target.value,
                              }))
                            }
                          />
                        </Form.Group>
                        <Form.Group className="mb-2">
                          <Form.Label className="font-medium">
                            Tab Subtitle (optional)
                          </Form.Label>
                          <Form.Control
                            placeholder="Tab Subtitle (optional)"
                            value={newTab.tabSubtitle}
                            onChange={(e) =>
                              setNewTab((prev) => ({
                                ...prev,
                                tabSubtitle: e.target.value,
                              }))
                            }
                          />
                        </Form.Group>
                      </div>
                      <div className="modal-footer">
                        <Button
                          type="button"
                          variant="success"
                          onClick={(e) => {
                            addFeatureTab(e);
                            const closeButton = document.querySelector(
                              "#feature-tab-modal [data-bs-dismiss='modal']",
                            );
                            if (closeButton) closeButton.click();
                          }}
                        >
                          {editingTabIndex !== null ? "Update Tab" : "Add Tab"}
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>

                {/* ══ Feature Item Modal (Add / Edit, shared across tabs) ══ */}
                <div className="modal fade" id="feature-item-modal">
                  <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                      <div className="modal-header">
                        <h5 className="modal-title">
                          {editingItemIndex !== null ? "Edit Item" : "Add Item"}
                        </h5>
                        <button
                          type="button"
                          className="btn-close"
                          data-bs-dismiss="modal"
                          aria-label="Close"
                        ></button>
                      </div>
                      <div className="modal-body">
                        <Form.Group className="mb-2">
                          <Form.Label className="font-medium">
                            Icon Image
                          </Form.Label>
                          {newItem.icon && (
                            <div className="mb-2 position-relative d-inline-block">
                              <img
                                src={
                                  newItem.icon instanceof File
                                    ? URL.createObjectURL(newItem.icon)
                                    : newItem.icon
                                }
                                alt="Icon Preview"
                                style={{
                                  width: "60px",
                                  height: "60px",
                                  objectFit: "cover",
                                  borderRadius: "8px",
                                  display: "block",
                                }}
                              />
                              <button
                                type="button"
                                className="position-absolute top-0 end-0 m-1 btn btn-sm p-0"
                                onClick={() => {
                                  setNewItem((prev) => ({
                                    ...prev,
                                    icon: null,
                                  }));
                                  if (itemIconInputRef.current)
                                    itemIconInputRef.current.value = "";
                                }}
                              >
                                <FontAwesomeIcon
                                  icon={faTimes}
                                  style={{
                                    color: "red",
                                    backgroundColor: "black",
                                    borderRadius: "3px",
                                    padding: "2px",
                                    fontSize: "0.8rem",
                                  }}
                                />
                              </button>
                            </div>
                          )}
                          <Form.Control
                            type="file"
                            accept="image/*"
                            ref={itemIconInputRef}
                            onChange={(e) => {
                              if (e.target.files[0])
                                setNewItem((prev) => ({
                                  ...prev,
                                  icon: e.target.files[0],
                                }));
                            }}
                          />
                        </Form.Group>
                        <Form.Group className="mb-2">
                          <Form.Label className="font-medium">
                            Item Title
                          </Form.Label>
                          <Form.Control
                            placeholder="Item Title"
                            value={newItem.title}
                            onChange={(e) =>
                              setNewItem((prev) => ({
                                ...prev,
                                title: e.target.value,
                              }))
                            }
                          />
                        </Form.Group>
                        <Form.Group className="mb-2">
                          <Form.Label className="font-medium">
                            Description
                          </Form.Label>
                          <textarea
                            className="form-control"
                            rows={2}
                            placeholder="Description"
                            value={newItem.description}
                            onChange={(e) =>
                              setNewItem((prev) => ({
                                ...prev,
                                description: e.target.value,
                              }))
                            }
                          />
                        </Form.Group>
                      </div>
                      <div className="modal-footer">
                        <Button
                          type="button"
                          variant="primary"
                          onClick={(e) => {
                            if (currentTabIndex !== null)
                              addFeatureItem(e, currentTabIndex);
                            const closeButton = document.querySelector(
                              "#feature-item-modal [data-bs-dismiss='modal']",
                            );
                            if (closeButton) closeButton.click();
                          }}
                        >
                          {editingItemIndex !== null
                            ? "Update Item"
                            : "Add Item"}
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>

                {/* ══ Layer Modal (Add / Edit) ══ */}
                <div className="modal fade" id="layer-modal">
                  <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                      <div className="modal-header">
                        <h5 className="modal-title">
                          {editingLayerIndex !== null
                            ? "Edit Layer"
                            : "Add Layer"}
                        </h5>
                        <button
                          type="button"
                          className="btn-close"
                          data-bs-dismiss="modal"
                          aria-label="Close"
                        ></button>
                      </div>
                      <div className="modal-body">
                        <Row>
                          <Col md={3}>
                            <Form.Control
                              type="number"
                              placeholder="Layer No."
                              value={newLayer.layerNumber}
                              onChange={(e) =>
                                setNewLayer({
                                  ...newLayer,
                                  layerNumber: e.target.value,
                                })
                              }
                            />
                          </Col>
                          <Col md={9}>
                            <Form.Control
                              placeholder="Layer Title"
                              value={newLayer.title}
                              onChange={(e) =>
                                setNewLayer({
                                  ...newLayer,
                                  title: e.target.value,
                                })
                              }
                            />
                          </Col>
                        </Row>
                        <Form.Control
                          className="mt-2"
                          placeholder="Subtitle"
                          value={newLayer.subtitle}
                          onChange={(e) =>
                            setNewLayer({
                              ...newLayer,
                              subtitle: e.target.value,
                            })
                          }
                        />
                        <textarea
                          className="form-control mt-2"
                          rows={2}
                          placeholder="Description"
                          value={newLayer.description}
                          onChange={(e) =>
                            setNewLayer({
                              ...newLayer,
                              description: e.target.value,
                            })
                          }
                        />
                        <Form.Label className="mt-2">Layer Image</Form.Label>
                        {newLayer.image && (
                          <div className="mb-2 position-relative d-inline-block">
                            <img
                              src={
                                newLayer.image instanceof File
                                  ? URL.createObjectURL(newLayer.image)
                                  : newLayer.image
                              }
                              alt="Layer Preview"
                              style={{
                                maxHeight: "100px",
                                borderRadius: "6px",
                                display: "block",
                              }}
                            />
                            <button
                              type="button"
                              className="position-absolute top-0 end-0 m-1 btn btn-sm p-0"
                              onClick={() =>
                                setNewLayer((prev) => ({
                                  ...prev,
                                  image: null,
                                }))
                              }
                            >
                              <FontAwesomeIcon
                                icon={faTimes}
                                style={{
                                  color: "red",
                                  backgroundColor: "black",
                                  borderRadius: "3px",
                                  padding: "2px",
                                  fontSize: "0.9rem",
                                }}
                              />
                            </button>
                          </div>
                        )}
                        <Form.Control
                          type="file"
                          accept="image/*"
                          onChange={(e) => {
                            if (e.target.files[0])
                              setNewLayer((prev) => ({
                                ...prev,
                                image: e.target.files[0],
                              }));
                          }}
                        />
                      </div>
                      <div className="modal-footer">
                        <Button
                          type="button"
                          variant="primary"
                          onClick={(e) => {
                            addLayer(e);
                            const closeButton = document.querySelector(
                              "#layer-modal [data-bs-dismiss='modal']",
                            );
                            if (closeButton) closeButton.click();
                          }}
                        >
                          {editingLayerIndex !== null
                            ? "Update Layer"
                            : "Add Layer"}
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              </Form>
            </Container>
          </div>
        </div>
      )}
    </div>
  );
}
